import { PurchaseOrderEditorComponent } from '../purchase-orders/purchase-order-editor.component';
import { Component, OnInit, Inject, ViewChild, AfterViewInit, ɵɵtrustConstantResourceUrl } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute } from '@angular/router';
import { OrderSummary } from '../order-details/order-details.interface';
import * as Info from './full-order-details.interfaces';
import * as Options from '../select-options';
import { map, of } from 'rxjs';
import { startWith, toArray } from 'rxjs/operators';
import { MatDialog, MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faChevronCircleUp, faChevronCircleDown, faClipboard, faFile } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { PostData } from 'src/app/full-page-order-maker/full-page-order-maker.component';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import SignaturePad from 'signature_pad';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { AgGridAngular } from 'ag-grid-angular';
//import { CHART_TOOL_PANEL_MENU_OPTIONS, ColDefUtil } from 'ag-grid-community';
import { ChartToolPanelMenuOptions } from 'ag-grid-community';
import {  IServerSideDatasource, IServerSideGetRowsParams, ICellRendererParams, IServerSideGetRowsRequest, RowNode, GridApi, GridOptions, CellEditingStoppedEvent, ValueFormatterParams } from 'ag-grid-community';
import { FinancialModalComponent } from './financial-modal/financial-modal.component';
import { RemoveServiceModalComponent } from './remove-service-modal/remove-service-modal.component';
import { FinancialCurrencyEditorComponent } from './financial-currency-editor/financial-currency-editor.component';
import { DocumentTypeSelectionDialog } from './document-type-selection-dialog';
import { ToastrService } from 'ngx-toastr';
import { SetValueModel } from 'ag-grid-enterprise/dist/types/set-filter/setFilter/setValueModel';

@Component({
  selector: 'app-full-order-details',
  templateUrl: './full-order-details.component.html',
  styleUrls: ['./full-order-details.component.scss'],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ],
})
export class FullOrderDetailsComponent implements OnInit {
  @ViewChild(PurchaseOrderEditorComponent) private purchaseOrders?: PurchaseOrderEditorComponent;
  canLeavePurchaseOrders(): boolean { return this.purchaseOrders?.canLeave() ?? true; }

  @ViewChild('signaturePad', { static: true }) signaturePad!: SignaturePadComponent;

  isDraggingOverDocument: boolean = false;

  collapseIcon = faChevronCircleUp;
  expandIcon = faChevronCircleDown;
  dockCheckIcon = faClipboard;
  invoicingIcon = faFile;

  STATUSES = Options.STATUSES;

  status_form_set: Array<FormGroup> = []; // stores status timeline data, can be edited by user
  originalStatusTimeline: Array<Info.StatusTimeline> = []; // keeps status timeline as retrieved from API in case of cancelled changes

  uuid: string | null = '';
  errorMessages: Array<string> = [];
  // data retrieved from apis
  documentList: any = '';
  signatureList: any = '';

  shipperAddress: Array<Info.Address> = [];
  consigneeAddress: Array<Info.Address> = [];
  operations: Info.Operations = {};

  //Just for displaying contact details in the shipper and consignee card
  shipper_info_text: string = '';
  consignee_info_text: string = '';

  // Angular doesn't like it when .addControl() is used
  // note: submit function requires that form control names match names in apis

  financialInfo: any = {};
  ladingServices: Array<{ [key: string]: string | number | object | boolean }> = [];
  serviceCategories: Array<{ [key: string]: string | number | object | boolean }> = [];
  // Set Financial Info Grid to be hidden until API call is complete
  showFinancialInfo: boolean = false;
  // Default financial grid is non-editable at start
  isFinancialGridEditToggled = false;

  checked_for_consolidation: boolean = false;
  consolidation_uuid: string | undefined | null;
  consolidation_status: string = '';
  consolidation_id: number = 0;
  associated_ladings: any[] = [];
  is_parent_lading: boolean = false;
  parent_lading_uuid: string = '';
  carrier_contact_uuid: string = '';

  // for adding lading to existing consolidation
  lading_form: FormGroup = this.fb.group({
    lading: new FormControl(''),
    lading_uuid: new FormControl('')
  })
  lading_list: Observable<any[]> | undefined;

  resetLadingForm(){
    this.lading_form.get('lading')?.setValue('');
    this.lading_form.get('lading_uuid')?.setValue('');
  }

  createConsol(){
    let body = {
      'lading_uuid': this.uuid,
      'carrier_contact_uuid': this.carrier_contact_uuid
    }
    let url = '/api/work_orders/consolidate_lading.php';
    this.http.post<any>(url, body, { headers: new HttpHeaders(), observe: "response" })
      .subscribe(response => {
        console.log('post response: ', response)
        if(response.ok == true){
          alert("Consolidation has been made successfully.");
        }
      });
  }

  addLadingToConsol(){
    if(this.lading_form.get('lading_uuid')?.value.length > 0){
      let body = {
        'column_name': 'lading_consolidation_uuid',
        'column_value': this.consolidation_uuid,
        'uuid': this.lading_form.get('lading_uuid')?.value,
        'remove': false
      }
      console.log(JSON.stringify(body));
      let url = '/api/work_orders/update_lading.php';
      this.http.post<any>(url, body, { headers: new HttpHeaders(), observe: "response" })
          .subscribe(response => {
            console.log('post response: ', response);

          });
    }
    location.reload();
  }

  removeLadingFromConsol(){
    console.log(`removing lading. alternate ref: ${this.lading_form.get('lading')?.value}. uuid: ${this.lading_form.get('lading_uuid')?.value}`)
    if(this.lading_form.get('lading_uuid')?.value.length > 0){
      let body = {
        'column_name': 'lading_consolidation_uuid',
        'column_value': this.consolidation_uuid,
        'uuid': this.lading_form.get('lading_uuid')?.value,
        'remove': true
      }
      console.log(`body: ${JSON.stringify(body)}`)
      let url = '/api/work_orders/update_lading.php';
      this.http.post<any>(url, body, { headers: new HttpHeaders(), observe: "response" })
          .subscribe(response => {
            console.log('post response: ', response);

          });
      location.reload();
    }
  }

  selectLading(item: any){
    console.log('selecting lading...')
    this.lading_form.get('lading_uuid')?.setValue(item.value);
  }

  selectLadingToRemove(item: any){
    this.lading_form.get('lading_uuid')?.setValue(item.uuid);
    console.log('selected lading uuid:',this.lading_form.get('lading_uuid')?.value)
  }

  getLadingList(query: string): Observable<string[]>{
    console.log('getting lading list...')
    let url = `/api/work_orders/query_ladings.php?type=alternate_reference&search_term=${query}`;
    return this.http.get<any[]>(url).pipe(
      map(response => {
        if(response){
          console.log('got a response:',JSON.stringify(response))
          return response;
        }
        else{
          return [];
        }
      })
    )
  }


  // will hold data for work_order_details api
  general_info: FormGroup = this.fb.group({
    pro_bill: [''],
    lading_number: [''], //BOL Number
    customer_name: [''],
    shipper_name: [''],
    consignee_name: [''],
    carrier_name: [''],
    alternate_reference: [''],
    lading_status: [''],
    trip_number: [''],
    drop_trailer_status: [''],
    hot: [false],
    expedited: [false],
    drop_trailer: [false],
    partial_or_full: [''],
    lading_id: [''], //fbi number
    shipment_number: [''],
    load_details: [''],
    load_weight: ['0'],
    load_weight_unit: [''],
    load_weight_actual: ['0'],
    load_length: ['0'],
    load_length_unit: [''],
    load_pallets: ['0'],
    load_pieces: ['0'],
    type_of_equipment: [''],
    appointment_date: ['1970-01-01'],
    appointment_start: ['00:00:00'],
    appointment_end: ['00:00:00'],
    load_start_date: ['1970-01-01'],
    load_start_time: ['00:00:00'],
    load_end_date: ['1970-01-01'],
    load_end_time: ['00:00:00'],
    load_special_info: [''],
    lading_uuid: [''],
    carrier_trailer: [''],
    week_no: ['']
  })

  work_order_details_properties = Object.keys(this.general_info.controls);


  shipper_info: FormGroup = this.fb.group({
    contact_uuid: [''],
    lading_site_check_uuid: [''],
    pickup_reference_number_required: [false],
    pickup_reference_number: [''],
    appointment: [false],
    loading_dock: [false],
    pickup_tailgate: [false],
    truck_space: [false],
    shipping_bol_required: [false],
    commercial: [false],
    residential: [false],
    job_site: [false],
    unmanned_job_site: [false],
    notification_at_pickup: [false],
    notification_delayed_pickup: [false],
    notification_at_delivery: [false],
    notification_delayed_delivery: [false],
    notification_assessorials_incured: [false],
    job_site_contact_name: [''],
    job_site_contact_phone: [''],
    appointment_contact_name: [''],
    appointment_contact_phone: [''],
  })

  uneditable_shipper_info: Info.UneditableSiteChecks = {
    job_site_contact_name: 'none',
    job_site_contact_phone: 'none',
    appointment_contact_name: 'none',
    appointment_contact_phone: 'none',
    pickup_reference_number: 'none'
  }


  consignee_info: FormGroup = this.fb.group({
    contact_uuid: [''],
    lading_site_check_uuid: [''],
    delivery_reference_number_required: [false],
    delivery_reference_number: [''],
    appointment: [false],
    loading_dock: [false],
    pickup_tailgate: [false],
    truck_space: [false],
    call_site: [false],
    commercial: [false],
    residential: [false],
    job_site: [false],
    unmanned_job_site: [false],
    convention_center: [false],
    pop_up_store: [false],
    notification_at_pickup: [false],
    notification_delayed_pickup: [false],
    notification_at_delivery: [false],
    notification_delayed_delivery: [false],
    notification_assessorials_incured: [false],
    job_site_contact_name: [''],
    job_site_contact_phone: [''],
    appointment_contact_name: [''],
    appointment_contact_phone: ['']
  })

  uneditable_consignee_info: Info.UneditableSiteChecks = {
    job_site_contact_name: 'none',
    job_site_contact_phone: 'none',
    appointment_contact_name: 'none',
    appointment_contact_phone: 'none',
    delivery_reference_number: 'none'
  }

  customer_info: FormGroup = this.fb.group({
    lading_site_check_uuid: [''],
    bol_required: [false],
    invoice_bol_required: [false],
    rate_quote_required: [false],
    invoice_po_required: [false],
    invoice_po: [''],
    notification_at_pickup: [false],
    notification_delayed_pickup: [false],
    notification_at_delivery: [false],
    notification_delayed_delivery: [false],
    notification_assessorials_incured: [false]
  })

  financial_info: FormGroup = this.fb.group({
    freight_net_cost_actual: [''],
    freight_net_cost: [''],
    freight_net_billable: [''],

    fuel_surcharge_rate_cost_actual: [''],
    fuel_rate_rated_cost: [''],
    fuel_rate_billable: [''],

    fuel_surcharge_plus_rate_cost_actual: [''],
    fuel_surcharge_plus_rate_cost: [''],
    fuel_surcharge_plus_rate_billed: [''],

    fuel_surcharge_cost_actual: [''],
    fuel_surcharge_cost: [''],
    fuel_surcharge_billed: [''],

    fuel_surcharge_plus_cost_actual: [''],
    fuel_surcharge_plus_cost: [''],
    fuel_surcharge_plus_billed: [''],

    beyond_cost_actual: [''],
    beyond_cost: [''],
    beyond_billed: [''],

    delivery_actual_cost: [''],
    delivery_rated_cost: [''],
    delivery_billable: [''],

    discount_rate: [''],

    tax_rate_multiplier_actual: [''],
    tax_rate_multiplier: [''],
    tax_rate_billed_multiplier: [''],

    costs_taxes_actual: [''],
    costs_taxes: [''],
    billable_taxes: [''],

    gross_actual_cost: [''],
    gross_rated_cost: [''],
    gross_billable: [''],

    total_costs_actual: [''],
    total_costs: [''],
    total_charged: [''],

    note_list: this.fb.array([
      this.fb.group({
        cost_note: [''],
        cost_types: ['']
      })
    ])
  })

  service_charge_info: FormGroup = this.fb.group({
    service_list: this.fb.array([
      this.fb.group({
        services: [''],
        service_types: ['']
      })
    ]),
  })

  carrier_info: FormGroup = this.fb.group({
    contact_uuid: [''],
    organization: [''],
    name: [''],
    street_address: [''],
    city: [''],
    postal_code: [''],
    country: [''],
    street_address_extended: [''],
    document_category: [''],
    document_type: [''],
    // new_carrier: [''],
    // new_carrier_address: [''],
  })

  new_carrier_info: FormGroup = this.fb.group({
    carrier_contact_control: [''],
    carrier_address_uuid: [''],
    carrier_contact_uuid: [''],
    old_carrier_task_uuid: [''],
  })

  new_shipper_info: FormGroup = this.fb.group({
    new_shipper_control: [''],
    shipper_address_uuid: [''],
    shipper_contact_uuid: [''],
    old_shipper_task_uuid: [''],
  })

  new_consignee_info: FormGroup = this.fb.group({
    new_consignee_control: [''],
    consignee_address_uuid: [''],
    consignee_contact_uuid: [''],
    old_consignee_task_uuid: [''],
  })

  operation_info: FormGroup = this.fb.group({
    lading_operation_uuid: [''],
    carrier_rated: [''],
    carrier_rerated: [''],
    straps_bars: [''],
    lift_lull: [''],
    call_site: [''],
    protective_equipment: [''],
    unmanned_job_site: [''],
    operations_notation: [''],
  })

  customer_care_info: FormGroup = this.fb.group({
    lading_care_uuid: [''],
    confirm_pick_up: [''],
    confirm_delivery: [''],
    pod_required: [''],
    purchase_order_required: [''],
    care_notation: [''],
  })

  sales_info: FormGroup = this.fb.group({
    lading_sale_uuid: [''],
    quote_required: [''],
    requote_required: [''],
    customer_rated: [''],
    sales_notation: [''],
    management_notation: [''],
  })

  administration_info: FormGroup = this.fb.group({
    lading_administration_uuid: [''],

    po_audited: [''],
    pod_audited: [''],
    confirm_charges: [''],
    carrier_invoiced: [''],
    freight_cost_approved: [''],
    freight_cost_exception: [''],
    ready_invoice: [''],
    damage_claim: [''],
    intent_claim: [''],
    claim_review: [''],
    invoice_thanks: [''],
    invoice_due: [''],

    invoice_correct: [''],
    invoice_late: [''],
    carrier_invoice_exported: [''],
    customer_invoice_exported: [''],
    customer_invoice_date: [''],
    freight_cost_notation: [''],
    versapay_payment_reference: [''],
    administration_notation: [''],
    special_invoice: [''],
  })

  claim_info: FormGroup = this.fb.group({
    load_damage_uuid: [''],
    customer_name: [''],
    fbi_reference: [''],
    date_notified: [''],
    date_sent_to_carrier: [''],
    date_sent: [''],
    claim_type: [''],
    claim: [''],
    claim_currency: [''],
    amount_paid_carrier: [''],
    date_paid_carrier: [''],
    amount_paid_fbi: [''],
    date_paid_fbi: [''],
    payment_method: [''],
    reason_for_declination: [''],
    load_damage_status: [''],
    damaged_unit: [''],
  })

  category_array: Array<string> = ['', 'General Documents'];

  constructor(private http: HttpClient, private route: ActivatedRoute, public dialog: MatDialog, private fb: FormBuilder, private router: Router, private toastr: ToastrService) { 

    window.addEventListener('dragover', (event) => {
      event.preventDefault();
    });

    window.addEventListener('drop', (event) => {
      event.preventDefault();
    });

  }

  //enable form functions
  enableGeneralInfo() {
    this.general_info.enable();
  }

  disableGeneralInfo() {
    this.general_info.disable();
  }

  enableShipperInfo() {
    this.shipper_info.enable();
  }

  disableShipperInfo() {
    this.shipper_info.disable();
  }

  enableConsigneeInfo() {
    this.consignee_info.enable();
    this.consignee_info.get('delivery_reference_number_required')?.disable();
    this.consignee_info.get('delivery_reference_number')?.disable();
    this.consignee_info.get('appointment_contact_name')?.disable();
    this.consignee_info.get('appointment_contact_phone')?.disable();
    this.consignee_info.get('job_site_contact_name')?.disable();
    this.consignee_info.get('job_site_contact_phone')?.disable();
  }

  disableConsigneeInfo() {
    this.consignee_info.disable();
  }

  enableCustomerInfo() {
    this.customer_info.enable();
  }

  disableCustomerInfo() {
    this.customer_info.disable();
  }

  enableFinancialInfo() {
    this.financial_info.enable();
  }

  disableFinancialInfo() {
    this.financial_info.disable();
  }

  enableOperationInfo() {
    this.operation_info.enable();
  }

  disableOperationInfo() {
    this.operation_info.disable();
  }

  enableCustomerCareInfo() {
    this.customer_care_info.enable();
  }

  disableCustomerCareInfo() {
    this.customer_care_info.disable();
  }

  enableSalesInfo() {
    this.sales_info.enable();
  }

  disableSalesInfo() {
    this.sales_info.disable();
  }

  enableAdministrationInfo() {
    this.administration_info.enable();
  }

  disableAdministrationInfo() {
    this.administration_info.disable();
  }

  searchCustomers(): Observable<any[]> {
    const url = `/api/work_orders/contact_autofill.php?type=customer_contact_list`;
    return this.http.get<any[]>(url);
  }

  isCheckboxDisabled = true;

  //Select new carrier
  carrierList: any[] = [];
  // new_carrier_control = new FormControl('');
  // new_carrier_address = new FormControl('');
  filteredCarrierList: Observable<string[]> | undefined;

  filterCarrierList(name: string) {
    return this.carrierList.filter(carrierList =>
      carrierList.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  //Select new shipper
  shipperList: any[] = [];
  new_shipper_address = new FormControl('');
  filteredShipperList: Observable<string[]> | undefined;

  filterShipperList(name: string) {
    return this.shipperList.filter(shipperList =>
      shipperList.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  //Select new consignee
  consigneeList: any[] = [];
  new_consignee_address = new FormControl('');
  filteredConsigneeList: Observable<string[]> | undefined;

  filterConsigneeList(name: string) {
    return this.consigneeList.filter(consigneeList =>
      consigneeList.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  //Populate carrier address list
  carrierAddresses: string[] = ['Select Carrier First'];
  carrierFullList: any[] | undefined;
  carrier_selected_uuid: string | undefined;

  carrierAddressList(): Observable<string[]> {
    if (this.carrier_selected_uuid) {
      return this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${this.carrier_selected_uuid}`)
        .pipe(
          map(response => {
            this.new_carrier_info.get('carrier_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid)
            console.log('carrier_address_uuid: ' + this.new_carrier_info.get('carrier_address_uuid')?.value);
            return response[0].addresses.map((item: any) => item.address + ' - ' + item.locality + ' - ' + item.region);
          })
        );
    }
    return new Observable<string[]>();
  }

  //Populate shipper address list
  shipperAddresses: string[] = ['Select Shipper First'];
  shipperFullList: any[] | undefined;
  shipper_selected_uuid: string | undefined;

  shipperAddressList(): Observable<string[]> {
    if (this.shipper_selected_uuid) {
      return this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${this.shipper_selected_uuid}`)
        .pipe(
          map(response => {
            this.new_shipper_info.get('shipper_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid)
            console.log('shipper_address_uuid: ' + this.new_shipper_info.get('shipper_address_uuid')?.value);
            return response[0].addresses.map((item: any) => item.address + ' - ' + item.locality + ' - ' + item.region);
          })
        );
    }
    return new Observable<string[]>();
  }

  //Populate consignee address list
  consigneeAddresses: string[] = ['Select Consignee First'];
  consigneeFullList: any[] | undefined;
  consignee_selected_uuid: string | undefined;

  consigneeAddressList(): Observable<string[]> {
    if (this.consignee_selected_uuid) {
      return this.http.get<any[]>(`/api/work_orders/contact_autofill.php?type=contact_data&uuid=${this.consignee_selected_uuid}`)
        .pipe(
          map(response => {
            this.new_consignee_info.get('consignee_address_uuid')?.setValue(response[0].addresses[0].contact_address_uuid)
            console.log('consignee_address_uuid: ' + this.new_consignee_info.get('consignee_address_uuid')?.value);
            return response[0].addresses.map((item: any) => item.address + ' - ' + item.locality + ' - ' + item.region);
          })
        );
    }
    return new Observable<string[]>();
  }

  //Populate Items Card
  packageArray: any[] = [];

  ngOnInit() {

    this.lading_form.get('lading')?.valueChanges.subscribe( value => {
      console.log('value changed')
      if (value.length >= 2){
        console.log('more than 2 characters in value')
        this.lading_list = this.getLadingList(value);
      }
    })

    //Populate the carrier address list in the switching contact feature
    this.new_carrier_info.get('carrier_contact_control')?.valueChanges.subscribe((data) => {
      const index = this.carrierFullList?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.carrierFullList && index !== undefined) {
        this.carrier_selected_uuid = this.carrierFullList[index]?.value;
        this.new_carrier_info.get('carrier_contact_uuid')?.setValue(this.carrier_selected_uuid);
        console.log('carrier_contact_uuid: ' + this.new_carrier_info.get('carrier_contact_uuid')?.value);
        if (this.carrier_selected_uuid) {
          this.carrierAddressList().subscribe(data => {
            this.carrierAddresses = data;
          });
        }
      }
    });

    //Populate the shipper address list in the switching contact feature
    this.new_shipper_info.get('new_shipper_control')?.valueChanges.subscribe((data) => {
      const index = this.shipperFullList?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.shipperFullList && index !== undefined) {
        this.shipper_selected_uuid = this.shipperFullList[index]?.value;
        this.new_shipper_info.get('shipper_contact_uuid')?.setValue(this.shipper_selected_uuid);
        console.log('shipper_contact_uuid: ' + this.new_shipper_info.get('shipper_contact_uuid')?.value);
        if (this.shipper_selected_uuid) {
          this.shipperAddressList().subscribe(data => {
            this.shipperAddresses = data;
          });
        }
      }
    });

    //Populate the consignee address list in the switching contact feature
    this.new_consignee_info.get('new_consignee_control')?.valueChanges.subscribe((data) => {
      const index = this.consigneeFullList?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.consigneeFullList && index !== undefined) {
        this.consignee_selected_uuid = this.consigneeFullList[index]?.value;
        this.new_consignee_info.get('consignee_contact_uuid')?.setValue(this.consignee_selected_uuid);
        console.log('consignee_contact_uuid: ' + this.new_consignee_info.get('consignee_contact_uuid')?.value);
        if (this.consignee_selected_uuid) {
          this.consigneeAddressList().subscribe(data => {
            this.consigneeAddresses = data;
          });
        }
      }
    });

    //Filter carrier list and Initialize carrier list
    this.getCarrierList().subscribe((data) => this.carrierList = data);
    this.filteredCarrierList = this.new_carrier_info.get('carrier_contact_control')?.valueChanges
      .pipe(
        startWith(''),
        map(carrierList => carrierList ? this.filterCarrierList(carrierList) : this.carrierList.slice())
      );

    //Filter shipper list and Initialize shipper list
    this.getShipperList().subscribe((data) => this.shipperList = data);
    this.filteredShipperList = this.new_shipper_info.get('new_shipper_control')?.valueChanges
      .pipe(
        startWith(''),
        map(shipperList => shipperList ? this.filterShipperList(shipperList) : this.shipperList.slice())
      );

    //Filter consignee list and Initialize consignee list
    this.getConsigneeList().subscribe((data) => this.consigneeList = data);
    this.filteredConsigneeList = this.new_consignee_info.get('new_consignee_control')?.valueChanges
      .pipe(
        startWith(''),
        map(consigneeList => consigneeList ? this.filterConsigneeList(consigneeList) : this.consigneeList.slice())
      );
    //disable financial_info form by default
    this.financial_info.disable();


    // get uuid
    this.route.paramMap.subscribe(params => {
      this.uuid = params.get('uuid');
    });

    let url = `/api/work_orders/work_orders_grid_details.php?uuid=${this.uuid}`;

    // call the work orders details api
    this.http.get<any>(url).subscribe(response => {
    if (response.lading) {

        this.checked_for_consolidation = true;
        this.carrier_contact_uuid = response.lading.carrier_contact_uuid;

        // check if lading is part of consolidation
        if(response.lading.lading_consolidation_uuid != null){
          this.consolidation_status = 'This order is part of a consolidation. ';
          this.consolidation_uuid = response.lading.lading_consolidation_uuid;
          this.getConsolidationInfo(response.lading.lading_consolidation_uuid, response.lading.lading_uuid);
        }
        else{
          this.consolidation_status = 'This order is not part of a consolidation.';
        }


        // set values for form controls
        this.general_info.get('lading_uuid')?.setValue(response.lading.lading_uuid);
        this.general_info.get('pro_bill')?.setValue(response.lading.pro_bill);
        this.general_info.get('trip_number')?.setValue(response.lading.trip_number);
        this.general_info.get('partial_or_full')?.setValue(response.lading.partial_or_full);
        this.general_info.get('shipment_number')?.setValue(response.lading.shipment_number);
        this.general_info.get('lading_id')?.setValue(response.lading.lading_id);
        this.general_info.get('alternate_reference')?.setValue(response.lading.alternate_reference);
        this.general_info.get('lading_number')?.setValue(response.lading.lading_number);
        this.general_info.get('shipper_name')?.setValue(response.lading.shipper_name);
        this.general_info.get('consignee_name')?.setValue(response.lading.consignee_name);
        this.general_info.get('customer_name')?.setValue(response.lading.customer_name);
        this.general_info.get('carrier_name')?.setValue(response.lading.carrier_name);
        this.general_info.get('drop_trailer_status')?.setValue(response.lading.drop_trailer_status);
        this.general_info.get('drop_trailer')?.setValue(response.lading.drop_trailer);
        this.general_info.get('hot')?.setValue(response.lading.hot);
        this.general_info.get('expedited')?.setValue(response.lading.expedited);
        this.general_info.get('lading_status')?.setValue(response.lading.lading_status);
        this.general_info.get('load_details')?.setValue(response.lading.load_details);
        this.general_info.get('load_weight')?.setValue(response.lading.load_weight);
        this.general_info.get('load_weight_actual')?.setValue(response.lading.load_weight_actual);
        this.general_info.get('load_weight_unit')?.setValue(response.lading.load_weight_unit);
        this.general_info.get('load_special_info')?.setValue(response.lading.load_special_info);
        this.general_info.get('load_length')?.setValue(response.lading.load_length);
        this.general_info.get('load_length_unit')?.setValue(response.lading.load_length_unit);
        this.general_info.get('load_pieces')?.setValue(response.lading.load_pieces);
        this.general_info.get('load_pallets')?.setValue(response.lading.load_pallets);
        this.general_info.get('type_of_equipment')?.setValue(response.lading.type_of_equipment);
        this.general_info.get('appointment_date')?.setValue(response.lading.appointment_date?.substring(0, 10) + 'T00:00:00');
        this.general_info.get('appointment_start')?.setValue(response.lading.appointment_start);
        this.general_info.get('appointment_end')?.setValue(response.lading.appointment_end);
        this.general_info.get('load_start_date')?.setValue(response.lading.load_start?.substring(0, 10) + 'T00:00:00');
        this.general_info.get('load_start_time')?.setValue(response.lading.load_start?.substring(11));
        this.general_info.get('load_end_date')?.setValue(response.lading.load_end?.substring(0, 10) + 'T00:00:00');
        this.general_info.get('load_end_time')?.setValue(response.lading.load_end?.substring(11));
        this.general_info.get('carrier_trailer')?.setValue(response.lading.carrier_trailer);
        this.general_info.get('week_no')?.setValue(null);
        if(response.lading.shipment_list.length > 0)
          this.general_info.get('week_no')?.setValue(response.lading.shipment_list[0].week_no);

        this.general_info.disable();
      }

      //poputlate carrier forms
      if (response.carrier.contact) {
        if (response.carrier.contact[0]) {
          this.carrier_info.get('contact_uuid')?.setValue(response.carrier['contact'][0].contact_uuid);
        }
        this.carrier_info.disable();
        this.carrier_info.get('document_category')?.enable();
        this.carrier_info.get('document_type')?.enable();
        this.carrier_info.get('new_carrier')?.enable();
        this.carrier_info.get('new_carrier_address')?.enable();
      }
      if (response.carrier['contact'][0]) {
        this.carrier_info.get('organization')?.setValue(response.carrier['contact'][0].contact_organization);
        let carrier_name_prefix: string = response.carrier['contact'][0].contact_name_prefix || "";
        let carrier_name_suffix: string = response.carrier['contact'][0].contact_name_suffix || "";
        let carrier_name_given: string = response.carrier['contact'][0].contact_name_given || "";
        let carrier_name_middle: string = response.carrier['contact'][0].contact_name_middle || "";
        let carrier_name_family: string = response.carrier['contact'][0].contact_name_family || "";
        let carrier_name: string = carrier_name_prefix + " " + carrier_name_given + " " + carrier_name_middle + " " + carrier_name_family + " " + carrier_name_suffix;
        this.carrier_info.get('name')?.setValue(carrier_name);
        this.carrier_info.get('street_address')?.setValue(response.carrier['address'][0].address_street);
        this.carrier_info.get('street_address_extended')?.setValue(response.carrier['address'][0].address_street_extended);
        this.carrier_info.get('city')?.setValue(response.carrier['address'][0].address_locality + " " + response.carrier['address'][0].address_region);
        this.carrier_info.get('postal_code')?.setValue(response.carrier['address'][0].address_postal_code);
        this.carrier_info.get('country')?.setValue(response.carrier['address'][0].address_country);
      }

      //Populate the items card
      if (response.lading['packages']) {
        this.packageArray = response.lading['packages'];
      }

      //populate the old_carrier_task_uuid for switching contact feature
      if (response.tasks) {
        response.tasks.forEach((element: any) => {
          if (element.task_type == "6") {
            this.new_carrier_info.get('old_carrier_task_uuid')?.setValue(element.lading_task_uuid);
          }
          if (element.task_type == "1") {
            this.new_shipper_info.get('old_shipper_task_uuid')?.setValue(element.lading_task_uuid);
          }
          if (element.task_type == "2") {
            this.new_shipper_info.get('old_consignee_task_uuid')?.setValue(element.lading_task_uuid);
          }
        });

      }


      // store shipper and consignee addresses
      if (response.shipper.address) {
        this.shipperAddress = response.shipper.address;

        //Display shipper information in shipper card
        for (const item of this.shipperAddress) {
          this.shipper_info_text += this.general_info.get('shipper_name')?.value + ' - ' + item.address_type + '\n' + item.address_street + '\n' + item.address_locality + ' '
            + item.address_region + ' ' + item.address_country + ' ' + item.address_postal_code;
          if (this.consigneeAddress.length > 1) {
            this.consignee_info_text += '\n\n'
          }
        }
        console.log(this.shipper_info_text)

      }
      if (response.consignee.address) {
        this.consigneeAddress = response.consignee.address;

        //Display consignee information in consignee card
        for (const item of this.consigneeAddress) {
          this.consignee_info_text += this.general_info.get('consignee_name')?.value + ' - ' + item.address_type + '\n' + item.address_street + '\n' + item.address_locality + ' '
            + item.address_region + ' ' + item.address_country + ' ' + item.address_postal_code;
          if (this.consigneeAddress.length > 1) {
            this.consignee_info_text += '\n\n'
          }
        }
      }

      if (response.shipper.contact[0]) {
        this.shipper_info.get('contact_uuid')?.setValue(response.shipper.contact[0].contact_uuid);
        this.shipper_info.disable();
      }
      // populate site check forms
      if (response.shipper.site_checks[0]) {
        this.shipper_info.get('lading_site_check_uuid')?.setValue(response.shipper.site_checks[0].lading_site_check_uuid);
        this.shipper_info.get('pickup_reference_number_required')?.setValue(response.shipper.site_checks[0].pickup_reference_number_required);
        this.shipper_info.get('pickup_reference_number')?.setValue(response.shipper.site_checks[0].pickup_reference_number)
        this.shipper_info.get('appointment')?.setValue(response.shipper.site_checks[0].appointment);
        this.shipper_info.get('loading_dock')?.setValue(response.shipper.site_checks[0].loading_dock);
        this.shipper_info.get('pickup_tailgate')?.setValue(response.shipper.site_checks[0].pickup_tailgate);
        this.shipper_info.get('truck_space')?.setValue(response.shipper.site_checks[0].truck_space);
        this.shipper_info.get('shipping_bol_required')?.setValue(response.shipper.site_checks[0].shipping_bol_required);
        this.shipper_info.get('commercial')?.setValue(response.shipper.site_checks[0].commercial);
        this.shipper_info.get('residential')?.setValue(response.shipper.site_checks[0].residential);
        this.shipper_info.get('job_site')?.setValue(response.shipper.site_checks[0].job_site);
        this.shipper_info.get('unmanned_job_site')?.setValue(response.shipper.site_checks[0].unmanned_job_site);
        this.shipper_info.get('notification_at_pickup')?.setValue(response.shipper.site_checks[0].notification_at_pickup);
        this.shipper_info.get('notification_delayed_pickup')?.setValue(response.shipper.site_checks[0].notification_delayed_pickup);
        this.shipper_info.get('notification_at_delivery')?.setValue(response.shipper.site_checks[0].notification_at_delivery);
        this.shipper_info.get('notification_delayed_delivery')?.setValue(response.shipper.site_checks[0].notification_delayed_delivery);
        this.shipper_info.get('notification_assessorials_incured')?.setValue(response.shipper.site_checks[0].notification_assessorials_incured);
        this.shipper_info.get('job_site_contact_name')?.setValue(response.shipper.site_checks[0].job_site_contact_name);
        this.shipper_info.get('job_site_contact_phone')?.setValue(response.shipper.site_checks[0].job_site_contact_phone);
        this.shipper_info.get('appointment_contact_name')?.setValue(response.shipper.site_checks[0].appointment_contact_name);
        this.shipper_info.get('appointment_contact_phone')?.setValue(response.shipper.site_checks[0].appointment_contact_phone);
        // set uneditable shipper info
        this.uneditable_shipper_info.appointment_contact_name = response.shipper.site_checks[0].appointment_contact_name == null ? 'none' : response.shipper.site_checks[0].appointment_contact_name;
        this.uneditable_shipper_info.appointment_contact_phone = response.shipper.site_checks[0].appointment_contact_phone == null ? 'none' : response.shipper.site_checks[0].appointment_contact_phone;
        this.uneditable_shipper_info.job_site_contact_name = response.shipper.site_checks[0].job_site_contact_name == null ? 'none' : response.shipper.site_checks[0].job_site_contact_name;
        this.uneditable_shipper_info.job_site_contact_phone = response.shipper.site_checks[0].job_site_contact_phone == null ? 'none' : response.shipper.site_checks[0].job_site_contact_phone;
        this.uneditable_shipper_info.pickup_reference_number = response.shipper.site_checks[0].pickup_reference_number == null ? 'none' : response.shipper.site_checks[0].pickup_reference_number;
        console.log('Appointment contact name is ' + this.uneditable_shipper_info.appointment_contact_name!.length + ' characters long');
      }

      if (response.consignee.contact[0]) {
        this.consignee_info.get('contact_uuid')?.setValue(response.consignee.contact[0].contact_uuid);
        this.consignee_info.disable();
      }
      if (response.consignee.site_checks[0]) {
        this.consignee_info.get('lading_site_check_uuid')?.setValue(response.consignee.site_checks[0].lading_site_check_uuid);
        this.consignee_info.get('delivery_reference_number_required')?.setValue(response.consignee.site_checks[0].delivery_reference_number_required);
        this.consignee_info.get('delivery_reference_number')?.setValue(response.consignee.site_checks[0].delivery_reference_number);
        this.consignee_info.get('appointment')?.setValue(response.consignee.site_checks[0].appointment);
        this.consignee_info.get('loading_dock')?.setValue(response.consignee.site_checks[0].loading_dock);
        this.consignee_info.get('pickup_tailgate')?.setValue(response.consignee.site_checks[0].pickup_tailgate);
        this.consignee_info.get('truck_space')?.setValue(response.consignee.site_checks[0].truck_space);
        this.consignee_info.get('call_site')?.setValue(response.consignee.site_checks[0].call_site);
        this.consignee_info.get('commercial')?.setValue(response.consignee.site_checks[0].commercial);
        this.consignee_info.get('residential')?.setValue(response.consignee.site_checks[0].residential);
        this.consignee_info.get('job_site')?.setValue(response.consignee.site_checks[0].job_site);
        this.consignee_info.get('unmanned_job_site')?.setValue(response.consignee.site_checks[0].unmanned_job_site);
        this.consignee_info.get('convention_center')?.setValue(response.consignee.site_checks[0].convention_center);
        this.consignee_info.get('pop_up_store')?.setValue(response.consignee.site_checks[0].pop_up_store);
        this.consignee_info.get('notification_at_pickup')?.setValue(response.consignee.site_checks[0].notification_at_pickup);
        this.consignee_info.get('notification_delayed_pickup')?.setValue(response.consignee.site_checks[0].notification_delayed_pickup);
        this.consignee_info.get('notification_at_delivery')?.setValue(response.consignee.site_checks[0].notification_at_delivery);
        this.consignee_info.get('notification_delayed_delivery')?.setValue(response.consignee.site_checks[0].notification_delayed_delivery);
        this.consignee_info.get('notification_assessorials_incured')?.setValue(response.consignee.site_checks[0].notification_assessorials_incured);
        // set uneditable info
        this.uneditable_consignee_info.appointment_contact_name = response.consignee.site_checks[0].appointment_contact_name == null ? 'none' : response.consignee.site_checks[0].appointment_contact_name;
        this.uneditable_consignee_info.appointment_contact_phone = response.consignee.site_checks[0].appointment_contact_phone == null ? 'none' : response.consignee.site_checks[0].appointment_contact_phone;
        this.uneditable_consignee_info.job_site_contact_name = response.consignee.site_checks[0].job_site_contact_name == null ? 'none' : response.consignee.site_checks[0].job_site_contact_name;
        this.uneditable_consignee_info.job_site_contact_phone = response.consignee.site_checks[0].job_site_contact_phone == null ? 'none' : response.consignee.site_checks[0].job_site_contact_phone;
        this.uneditable_consignee_info.delivery_reference_number = response.consignee.site_checks[0].delivery_reference_number == null ? 'none' : response.consignee.site_checks[0].delivery_reference_number;
      }
      if (response.customer.site_checks[0]) {
        this.customer_info.get('lading_site_check_uuid')?.setValue(response.customer.site_checks[0].lading_site_check_uuid);
        this.customer_info.get('notification_at_pickup')?.setValue(response.customer.site_checks[0].notification_at_pickup);
        this.customer_info.get('notification_delayed_pickup')?.setValue(response.customer.site_checks[0].notification_delayed_pickup);
        this.customer_info.get('notification_at_delivery')?.setValue(response.customer.site_checks[0].notification_at_delivery);
        this.customer_info.get('notification_delayed_delivery')?.setValue(response.customer.site_checks[0].delayed_delivery);
        this.customer_info.get('notification_assessorials_incured')?.setValue(response.customer.site_checks[0].notification_assessorials_incured);
        this.customer_info.get('bol_required')?.setValue(response.customer.site_checks[0].bol_required);
        this.customer_info.get('invoice_bol_required')?.setValue(response.customer.site_checks[0].invoice_bol_required);
        this.customer_info.get('rate_quote_required')?.setValue(response.customer.site_checks[0].rate_quote_required);
        this.customer_info.get('invoice_po_required')?.setValue(response.customer.site_checks[0].invoice_po_required);
        this.customer_info.get('invoice_po')?.setValue(response.customer.site_checks[0].invoice_po);
      }
      this.customer_info.disable();

      if (response.lading.operations[0]) {
        this.operations = response.lading.operations[0];
        this.operation_info.get('lading_operation_uuid')?.setValue(response.lading.operations[0]['lading_operation_uuid']);
        this.operation_info.get('carrier_rated')?.setValue(response.lading.operations[0]['carrier_rated']);
        this.operation_info.get('carrier_rerated')?.setValue(response.lading.operations[0]['carrier_rerated']);
        this.operation_info.get('straps_bars')?.setValue(response.lading.operations[0]['straps_bars']);
        this.operation_info.get('lift_lull')?.setValue(response.lading.operations[0]['lift_lull']);
        this.operation_info.get('call_site')?.setValue(response.lading.operations[0]['call_site']);
        this.operation_info.get('protective_equipment')?.setValue(response.lading.operations[0]['protective_equipment']);
        this.operation_info.get('unmanned_job_site')?.setValue(response.lading.operations[0]['unmanned_job_site']);
        this.operation_info.get('operations_notation')?.setValue(response.lading.operations[0]['operations_notation']);
        this.operation_info.disable();
      }
      else {
        let postData = {
          lading_uuid: this.uuid
        }
        let operations_url = `/api/work_orders/lading_operations.php`
        this.http.post<any>(operations_url, postData, { headers: new HttpHeaders(), observe: "response" })
          .subscribe(response => console.log('post response: ', response));

        this.http.get<any>(operations_url).subscribe(response => {
          if (response[0]) {
            this.operations = response[0];
          }
        })
      }

      if (response.lading.cares[0]) {
        this.customer_care_info.get('lading_care_uuid')?.setValue(response.lading.cares[0]['lading_care_uuid']);
        this.customer_care_info.get('confirm_pick_up')?.setValue(response.lading.cares[0]['confirm_pick_up']);
        this.customer_care_info.get('confirm_delivery')?.setValue(response.lading.cares[0]['confirm_delivery']);
        this.customer_care_info.get('pod_required')?.setValue(response.lading.cares[0]['pod_required']);
        this.customer_care_info.get('purchase_order_required')?.setValue(response.lading.cares[0]['purchase_order_required']);
        this.customer_care_info.get('care_notation')?.setValue(response.lading.cares[0]['care_notation']);
        this.customer_care_info.disable();
      }

      if (response.lading.sales[0]) {
        this.sales_info.get('lading_sale_uuid')?.setValue(response.lading.sales[0]['lading_sale_uuid']);
        this.sales_info.get('quote_required')?.setValue(response.lading.sales[0]['quote_required']);
        this.sales_info.get('requote_required')?.setValue(response.lading.sales[0]['requote_required']);
        this.sales_info.get('customer_rated')?.setValue(response.lading.sales[0]['customer_rated']);
        this.sales_info.get('sales_notation')?.setValue(response.lading.sales[0]['sales_notation']);
        this.sales_info.get('management_notation')?.setValue(response.lading.sales[0]['management_notation']);
        this.sales_info.disable();
      }

      if (response.lading.administrations[0]) {
        this.administration_info.get('lading_administration_uuid')?.setValue(response.lading.administrations[0]['lading_administration_uuid']);

        this.administration_info.get('po_audited')?.setValue(response.lading.administrations[0]['po_audited']);
        this.administration_info.get('pod_audited')?.setValue(response.lading.administrations[0]['pod_audited']);
        this.administration_info.get('confirm_charges')?.setValue(response.lading.administrations[0]['confirm_charges']);
        this.administration_info.get('carrier_invoiced')?.setValue(response.lading.administrations[0]['carrier_invoiced']);
        this.administration_info.get('freight_cost_approved')?.setValue(response.lading.administrations[0]['freight_cost_approved']);
        this.administration_info.get('freight_cost_exception')?.setValue(response.lading.administrations[0]['freight_cost_exception']);
        this.administration_info.get('ready_invoice')?.setValue(response.lading.administrations[0]['ready_invoice']);
        this.administration_info.get('damage_claim')?.setValue(response.lading.administrations[0]['damage_claim']);
        this.administration_info.get('intent_claim')?.setValue(response.lading.administrations[0]['intent_claim']);
        this.administration_info.get('claim_review')?.setValue(response.lading.administrations[0]['claim_review']);
        this.administration_info.get('invoice_thanks')?.setValue(response.lading.administrations[0]['invoice_thanks']);
        this.administration_info.get('invoice_due')?.setValue(response.lading.administrations[0]['invoice_due']);

        this.administration_info.get('invoice_correct')?.setValue(response.lading.administrations[0]['invoice_correct']);
        this.administration_info.get('invoice_late')?.setValue(response.lading.administrations[0]['invoice_late']);
        this.administration_info.get('carrier_invoice_exported')?.setValue(response.lading.administrations[0]['carrier_invoice_exported']);
        this.administration_info.get('customer_invoice_exported')?.setValue(response.lading.administrations[0]['customer_invoice_exported']);
        this.administration_info.get('customer_invoice_date')?.setValue(response.lading.administrations[0]['customer_invoice_date']);
        this.administration_info.get('freight_cost_notation')?.setValue(response.lading.administrations[0]['freight_cost_notation']);
        this.administration_info.get('versapay_payment_reference')?.setValue(response.lading.administrations[0]['versapay_payment_reference']);
        this.administration_info.get('administration_notation')?.setValue(response.lading.administrations[0]['administration_notation']);
        this.administration_info.get('special_invoice')?.setValue(response.lading.administrations[0]['special_invoice']);

        this.administration_info.disable();
      }

      //populate the category selection list in the carrier card
      if (response['lading']['scopes'][0]) {
        if (response['lading']['scopes'][0].lading_scope == 5) {
          if (response['shipper']['address'][0]['address_region'].indexOf('can') !== -1) {
            this.category_array.push('Household Into US');
          }
          else {
            this.category_array.push('Household Into CAN');
          }
        }
      }



      this.originalStatusTimeline = response.lading.status_timeline;
      console.log(this.originalStatusTimeline);

      // add status timeline data to forms
      for (let i = 0; i < response.lading.status_timeline.length; i++) {
        // set up a new form with status data 
        // note: each form group must be newly created or else changing one status will change every status
        let status_form = new FormGroup({
          status: new FormControl({ value: response.lading.status_timeline[i].lading_status, disabled: true }),
          date_created: new FormControl({ value: response.lading.status_timeline[i].local_time.slice(0, 10), disabled: true }),
          time_created: new FormControl({ value: response.lading.status_timeline[i].local_time.slice(11, 16), disabled: true }),
          lading_uuid: new FormControl({ value: response.lading.status_timeline[i].lading_uuid }),
          lading_status_timeline_uuid: new FormControl({ value: response.lading.status_timeline[i].lading_status_timeline_uuid })
        })
        // add new status to timeline
        this.status_form_set.push(status_form);
      }

    });

    // get documents
    let documents_url = `/api/work_orders/order_documents.php?uuid=${this.uuid}`;
    this.http.get<any>(documents_url).subscribe(response => {
      if (response) {
        this.documentList = response;
      }
    })

    // get signatures
    let signatures_url = `/api/work_orders/signature_list.php?uuid=${this.uuid}`;
    this.http.get<any>(signatures_url).subscribe(response => {
      this.signatureList = response;
    })

    // retrieve lading services for financial info, if any
    let lading_services_url = `/api/work_orders/lading_service_rates.php?uuid=${this.uuid}`;
    this.http.get<any>(lading_services_url).subscribe(response => {
      this.ladingServices = response;
    })

    // retrieve financial info
    let financials_url = `/api/work_orders/work_order_details_financial.php?uuid=${this.uuid}`;
    this.http.get<any>(financials_url).subscribe(response => {

      this.financialInfo = response;

      this.financialRowData = [
        { lading_service_rate_uuid: null, category: 'Currency', rated_cost: this.financialInfo.cost_currency_type, actual_cost: this.financialInfo.actual_currency_type, billable: this.financialInfo.chargeable_currency_type },
        { lading_service_rate_uuid: null, category: 'Freight Net Cost', rated_cost: this.financialInfo.freight_net_cost, actual_cost: this.financialInfo.freight_net_cost_actual, billable: this.financialInfo.freight_net_billable },
        { lading_service_rate_uuid: null, category: 'Fuel Surcharge Rate', rated_cost: this.financialInfo.fuel_surcharge_rate_cost, actual_cost: this.financialInfo.fuel_surcharge_rate_cost_actual, billable: this.financialInfo.fuel_surcharge_rate_billed },
        { lading_service_rate_uuid: null, category: 'Fuel Surcharge Plus Rate', rated_cost: this.financialInfo.fuel_surcharge_plus_rate_cost, actual_cost: this.financialInfo.fuel_surcharge_plus_rate_cost_actual, billable: this.financialInfo.fuel_surcharge_plus_rate_billed },
        { lading_service_rate_uuid: null, category: 'Fuel Surcharge', rated_cost: this.financialInfo.fuel_surcharge_cost, actual_cost: this.financialInfo.fuel_surcharge_cost_actual, billable: this.financialInfo.fuel_surcharge_billed },
        { lading_service_rate_uuid: null, category: 'Fuel Surcharge Plus', rated_cost: this.financialInfo.fuel_surcharge_plus_cost, actual_cost: this.financialInfo.fuel_surcharge_plus_cost_actual, billable: this.financialInfo.fuel_surcharge_plus_billed },
        { lading_service_rate_uuid: null, category: 'Beyond', rated_cost: this.financialInfo.beyond_cost, actual_cost: this.financialInfo.beyond_cost_actual, billable: this.financialInfo.beyond_billed },
        { lading_service_rate_uuid: null, category: 'Discount Rate', rated_cost: '', actual_cost: '', billable: this.financialInfo.discount_rate },
        { lading_service_rate_uuid: null, category: 'Tax Rate', rated_cost: this.financialInfo.tax_rate_multiplier, actual_cost: this.financialInfo.tax_rate_multiplier_actual, billable: this.financialInfo.tax_rate_billed_multiplier },
        { lading_service_rate_uuid: null, category: 'Tax', rated_cost: this.financialInfo.costs_taxes, actual_cost: this.financialInfo.costs_taxes_actual, billable: this.financialInfo.billable_taxes },
        { lading_service_rate_uuid: null, category: 'Gross', rated_cost: this.financialInfo.gross_costs, actual_cost: this.financialInfo.gross_costs_actual, billable: this.financialInfo.gross_billed },
        { lading_service_rate_uuid: null, category: 'Total', rated_cost: this.financialInfo.total_costs, actual_cost: this.financialInfo.total_costs_actual, billable: this.financialInfo.total_charged },
      ]

      // index to insert any lading services to the financial info
      let rowIndex = 7;

      // if lading services exist, add to the financial info data
      this.ladingServices.forEach((rowDataObject) => {
        // Create a new row based on the service
        const newRow = {
          lading_service_rate_uuid: rowDataObject['lading_service_rate_uuid'],
          category: rowDataObject['lading_service_rate'] + " | " + rowDataObject['lading_service_rate_type'],
          rated_cost: rowDataObject['service_cost'],
          actual_cost: rowDataObject['service_cost_actual'],
          billable: rowDataObject['service_billed'],
        };

        // Insert the new service at the 6th index
        this.financialRowData.splice(rowIndex, 0, newRow);
        rowIndex++;
      });

      // Check if all fields are empty for each object in financialRowData
      const isEmpty = this.financialRowData.every(row =>
        row.rated_cost === null || row.rated_cost === undefined || row.rated_cost === '' &&
        row.actual_cost === null || row.actual_cost === undefined || row.actual_cost === '' &&
        row.billable === null || row.billable === undefined || row.billable === ''
      );

      // If all fields are empty, set financialRowData to an empty array
      if (isEmpty) {
        this.financialRowData = [];
      }

      // display the AG-Grid after the API call is completed
      this.showFinancialInfo = true;

      // auto size grid to fit full width of grid horizontally
      // this.gridApi.sizeColumnsToFit();

      // Populate service categories array for remove-service-modal
      this.serviceCategories = this.ladingServices.map(service => ({
        category: `${service['lading_service_rate']} | ${service['lading_service_rate_type']}`,
        uuid: service['lading_service_rate_uuid']
      }));

    })

    // retrieve products info
    let products_url = `/api/work_orders/products.php?uuid=${this.uuid}`;
    this.http.get<any>(products_url).subscribe(response => {

      this.productsList = response

    })

  }

  getConsolidationInfo(consol_uuid: string, lading_uuid: string){
    let url = '/api/manifests/manifest.php';
    let body = {
      lading_uuid: lading_uuid,
      consolidation_uuid: consol_uuid
    }
    this.http.get<any>(url, {params: body}).subscribe(
      (response) => {
        console.log(response);
        this.consolidation_status += `Consolidation id: ${response.consolidation_id}.`;
        this.consolidation_id = response.consolidation_id;
        this.associated_ladings = response.other_ladings_in_consolidation;
        this.is_parent_lading = response.is_parent_lading;
        this.parent_lading_uuid = response.parent_lading_uuid;
      }
    )
  }

  // set up grid API to auto size grids used in the work details page
  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api
    this.gridApi = params.api;
    // if (this.showFinancialInfo) {
    //   this.gridApi.sizeColumnsToFit();
    // }
    // Resize columns to fit the grid width
    // this.gridApi?.addEventListener('firstDataRendered', () => {
      // this.autoSizeAll(false);
    // });

  }

  // auto size Products grid
  onProductsGridReady(params: any) {
    this.gridApi = params.api
    this.gridApi = params.api;
    // Resize columns to fit the grid width
    this.gridApi?.addEventListener('firstDataRendered', () => {
      this.autoSizeAll(false);
    });
  }

  // auto size the columns in the ag-grid
  autoSizeAll(skipHeader: boolean) {
    const allColumnIds: string[] = [];
    this.gridApi.getColumns()!.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    this.gridApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  // go back to dashboard upon button click
  goBack() {
    this.router.navigate(['/']);
  }

  // toggles disabled property for individual statuses
  async toggleStatusEdit(index: number) {
    if (this.status_form_set[index].disabled) {
      this.status_form_set[index].enable();
    }
    else {
      this.status_form_set[index].disable();

      //turn the status from a formgroup to an object for POST
      let postData = {
        lading_status: this.status_form_set[index].get('status')?.value,
        created: this.status_form_set[index].get('date_created')?.value.concat(' ').concat(this.status_form_set[index].get('time_created')?.value).concat(':00'),
        lading_uuid: this.status_form_set[index].get('lading_uuid')?.value.value,
        lading_status_timeline_uuid: this.status_form_set[index].get('lading_status_timeline_uuid')?.value.value
      }
      // post status data
      let r = await this.http.post<any>('/api/work_orders/status_timeline.php', postData, { headers: new HttpHeaders(), observe: 'response' }).subscribe(response => console.log(response));
    }
  }

  deleteStatus(index: number) {
    // delete status in database
    let uuid = this.status_form_set[index].get('lading_status_timeline_uuid')?.value.value;
    this.http.delete<any>(`/api/work_orders/status_timeline.php?uuid=${uuid}`)
      .subscribe(response => console.log(response));

    // delete status on page
    this.status_form_set.splice(index, 1);
  }

  // if user cancels status changes, reset data to values from API
  cancelStatusChange(index: number) {
    this.status_form_set[index].get('status')?.setValue(this.originalStatusTimeline[index].lading_status);
    this.status_form_set[index].get('date_created')?.setValue(this.originalStatusTimeline[index].created.slice(0, 10));
    this.status_form_set[index].get('time_created')?.setValue(this.originalStatusTimeline[index].created.slice(11, 16));

    this.status_form_set[index].disable();
  }

  addSignature() {
    this.signaturePad.saveSignature();

    // signatureImg will exist only if required signature info has been filled out
    if (this.signaturePad.signatureImg) {
      let url = '/api/work_orders/signature.php';
      let postData = {
        signature_capture: this.signaturePad.signatureImg,
        lading_uuid: this.uuid,
        file_format: 'PNG',
        signatory: this.signaturePad.getSignatory()
        // add date, lading_task_uuid, file_format, signatory
      }
      this.signaturePad.clear();
    }
    else {
    }

  }

  // view signature image
  async viewSignature(signature_info: any) {
    var base64: string = '';
    let signature_url = `/api/work_orders/signature.php?uuid=${signature_info.signature_uuid}`;
    let signature_response = await this.http.get<any>(signature_url).toPromise();

    if (signature_response) {
      base64 = signature_response[0].signature_capture;
    }
    else {
      console.log('signature not found');
      return;
    }

    let byteArray = new Uint8Array(
      window.atob(base64).split("").map(char => char.charCodeAt(0))
    );

    var file: Blob = new Blob([byteArray], { type: `image/${signature_info.file_format}` });
    let fileURL = URL.createObjectURL(file);
    let dialogRef = this.dialog.open(DocumentModalComponent, {
      width: '90vw',
      data: { fileURL: fileURL }
    })
  }

  // open a document
  async openModal(file_info: any) {
    var base64: string = '';

    // get document contents
    let document_url = `/api/work_orders/document_content.php?document_uuid=${file_info.upload_document_uuid}&file_name=${file_info.file_name}&file_format=${file_info.file_format}&type=${file_info.file_type}`;
    const r = await this.http.get<any>(document_url).toPromise();

    if (r) {
      base64 = r;
    }
    else {
      console.log('document not found');
      return;
    }

    // convert document contents
    const byteArray = new Uint8Array(
      window.atob(base64).split("").map(char => char.charCodeAt(0))
    );

    // if tiff, allow download. if image, open in modal. if pdf, open in new tab
    if (['png', 'jpg', 'jpeg', 'tif'].indexOf(file_info.file_format) > -1) {
      var file: Blob;
      if (file_info.file_format === 'tif') {
        file = new Blob([byteArray], { type: 'image/tiff' });
      }
      else {
        file = new Blob([byteArray], { type: `image/${file_info.file_format}` });
      }
      const fileURL = URL.createObjectURL(file);

      if (file_info.file_format === 'tif') {
        window.open(fileURL);
      }
      else {
        let dialogRef = this.dialog.open(DocumentModalComponent, {
          width: '90vw',
          data: { fileURL: fileURL }
        })
      }
    }
    else if (file_info.file_format === 'pdf') {
      console.log('file is a pdf')
      const file = new Blob([byteArray], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      const newWindow = window.open(fileURL, '_blank');

      /* TO DOWNLOAD PDF (must also include the byteArray:Uint8Array, file:Blob, and fileURL:URL above)
      let pdfName = file_info.file_name;
      let windowNav: any = window.navigator;

      if(windowNav && windowNav.msSaveOrOpenBlob){
        windowNav.msSaveOrOpenBlob(file, pdfName);
      }
      else{
        // create a link element
        let link = document.createElement('a');
        link.download = pdfName;
        link.target = '_blank';

        // add link and click it
        link.href = fileURL;
        document.body.appendChild(link);
        link.click();

        // clean up DOM
        document.body.removeChild(link);
      }
      */
    }
  }

  // Helper function to pad single-digit numbers with a leading zero
  padZero(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }

  // Converts a Date to string of mm/dd/yyyy format
  convertDate(date: any) {
    // Get day, month, and year from dateObject
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month is 0-based
    const year = date.getFullYear();

    // Construct the formatted date string
    const formattedDate = this.padZero(month) + '/' + this.padZero(day) + '/' + year;

    return formattedDate;
  }

  // submit changes to page
  submitForm() {
    type PostData = { [key: string]: any };

    // handle posting to work_order_details api
    const post_data: PostData = {};
    let general_info_properties = Object.keys(this.general_info.controls);

    // add general order info to post data
    for (let i = 0; i < general_info_properties.length; i++) {
      // add info to post data if "touched" by user, or is lading uuid
      if (!this.general_info.get(general_info_properties[i])?.pristine || general_info_properties[i] === 'lading_uuid') {
        post_data[general_info_properties[i]] = this.general_info.get(general_info_properties[i])?.value;
      }
    }

    // modify datetime info to match formats in database
    if (post_data['load_start_date'] || post_data['load_start_time']) {
      let formattedDateString = this.convertDate(this.general_info.get('load_start_date')?.value);
      let start_time = this.general_info.get('load_start_time')?.value ?? '00:00:00';
      post_data['load_start'] = formattedDateString + ' ' + start_time;
      console.log("Load Start: ", post_data['load_start'] );
      delete post_data['load_start_date'];
      delete post_data['load_start_time'];
    }
    if (post_data['load_end_date'] || post_data['load_end_time']) {
      let formattedDateString = this.convertDate(this.general_info.get('load_end_date')?.value);
      let end_time = this.general_info.get('load_end_time')?.value ?? '00:00:00';
      post_data['load_end'] = formattedDateString + ' ' + end_time;
      delete post_data['load_end_date'];
      delete post_data['load_end_time'];
    }
    if (post_data['appointment_date']) {
      let formattedDateString = this.convertDate(post_data['appointment_date'] )
      post_data['appointment_date'] = formattedDateString + ' 00:00:00';
      console.log("Appointment Date: ", post_data['appointment_date'] );
    }

    // send post request
    let url = `/api/work_orders/work_orders_grid_details.php?uuid=${this.uuid}`;
    if (Object.keys(post_data).length > 1) {
      this.http.post<any>(url, post_data, { headers: new HttpHeaders(), observe: "response" }).
        subscribe(response => { console.log("Post response: ", response) });
    }

    this.postToSiteChecks(this.shipper_info);
    this.postToSiteChecks(this.consignee_info);
    this.postToSiteChecks(this.customer_info);

    this.postToSiteChecks(this.carrier_info);

    this.general_info.disable();

  }

  // helper function - handles post requests to site checks api
  postToSiteChecks(form: FormGroup) {
    let post_data: PostData = {};
    let properties = Object.keys(form.controls);
    for (let i = 0; i < properties.length; i++) {
      if (!form.get(properties[i])?.pristine || properties[i] === 'lading_site_check_uuid') {
        if (form.get(properties[i])?.value == false) {
          post_data[properties[i]] = null;
        }
        else {
          post_data[properties[i]] = form.get(properties[i])?.value;
        }
      }
    }

    console.log('site checks post data is:')
    console.log(post_data);

    let site_check_url = '/api/work_orders/lading_site_checks.php';
    // if any info was changed, send post request to site checks api
    if (Object.keys(post_data).length > 1) {
      this.http.post<any>(site_check_url, post_data, { headers: new HttpHeaders(), observe: "response" })
        .subscribe(response => console.log(response));
    }
  }


  validateDate(start: string, end: string) {
    let start_year = +start.substring(0, 4);
    let end_year = +end.substring(0, 4);
    let start_month = +start.substring(5, 7);
    let end_month = +end.substring(5, 7);
    let start_day = +start.substring(8, 10);
    let end_day = +end.substring(8, 10);

    if (start_year > end_year) return false;
    else if ((start_year == end_year) && (start_month > end_month)) return false;
    else if ((start_year == end_year) && (start_month == end_month) && (start_day > end_day)) return false;
    else return true;
  }

  validateTime(start: string, end: string): boolean {
    let start_hour = +start.substring(0, 2);
    let end_hour = +end.substring(0, 2);
    let start_min = +start.substring(3, 5);
    let end_min = +end.substring(3, 5);

    if (start_hour > end_hour) return false;
    if ((start_hour === end_hour) && (start_min > end_min)) return false;
    return true;
  }

  // workaround to access lading status options; statuses not directly accessible in html
  getLadingStatuses() {
    return Options.STATUSES;
  }

  getNoteTypes() {
    return Options.NOTETYPES;
  }

  getEquipmentTypes() {
    return Options.TRAILER_TYPES;
  }

  getServices() {
    return Options.SERVICES;
  }

  getCategory() {
    return this.category_array;
  }

  getCurrency() {
    return ['USD', 'CAD', 'Other'];
  }

  getServiceType(service: string): string[] {
    let serviceTypes = [''];

    if (service === 'Service Program') {
      serviceTypes = Options.SERVICE_PROGRAM;
    }
    else if (service === 'Accessorial Service') {
      serviceTypes = Options.ACCESSORIAL_TYPE;
    }
    else if (service === 'Surcharge Service') {
      serviceTypes = Options.SURCHARGE_TYPE;
    }
    else if (service === 'Tradeshow Service') {
      serviceTypes = Options.TRADESHOW_TYPE;
    }
    else if (service === 'Trailer Build Service') {
      serviceTypes = Options.TRAILER_BUILD_TYPE;
    }
    else if (service === 'Suncor Service') {
      serviceTypes = Options.SUNCOR_TYPE;
    }
    else if (service === 'Customs Service') {
      serviceTypes = Options.CUSTOMS_TYPE;
    }
    else if (service === 'Delivery Service') {
      serviceTypes = Options.DELIVERY_TYPE;
    }
    else if (service === 'Pickup Service') {
      serviceTypes = Options.PICKUP_TYPE;
    }
    else {
      serviceTypes = Options.LABOURER_TYPE;
    }

    return serviceTypes;
  }

  getCategoryType(category: string) {
    let categoryTypes = [''];

    if (category === 'General Documents') {
      const keyValueArray = Object.entries(Options.GENERAL_DOCUMENT);
      categoryTypes = keyValueArray.map(([key, value]) => value);
    }
    else if (category === 'Household Into US') {
      const keyValueArray = Object.entries(Options.HOUSEHOLD_INTO_US);
      categoryTypes = keyValueArray.map(([key, value]) => value);
    }
    else if (category === 'Household Into CAN') {
      const keyValueArray = Object.entries(Options.HOUSEHOLD_INTO_CAN);
      categoryTypes = keyValueArray.map(([key, value]) => value);
    }
    else {
      categoryTypes = [''];
    }

    return categoryTypes;
  }

  // openFinancialModal() {
  //   const element = document.getElementById("financial-light");
  //   if (element) {
  //     // this.dialog.open();
  //   }

  // }


  //Add more cost note fields
  get note_list() {
    return this.financial_info.controls["note_list"] as FormArray;
    // return this.financial_info.get('note_list') as FormArray;
  }

  addNote() {
    const sub_note_form = this.fb.group({
      cost_note: [''],
      cost_types: ['']
    });
    this.note_list.push(sub_note_form);
  }

  deleteNote(index: number) {
    this.note_list.removeAt(index);
  }

  get service_list() {
    return this.service_charge_info.controls["service_list"] as FormArray;
    // return this.financial_info.get('note_list') as FormArray;
  }

  addService() {
    const sub_service_form = this.fb.group({
      services: [''],
      service_types: ['']
    });
    this.service_list.push(sub_service_form);
  }

  deleteService(index: number) {
    this.service_list.removeAt(index);
  }

  getCarrierDetails() {
    this.router.navigate(['/contacts'], { queryParams: { contact_uuid: this.carrier_info.get('contact_uuid')?.value } });
  }

  getShipperDetails() {
    this.router.navigate(['/contacts'], { queryParams: { contact_uuid: this.shipper_info.get('contact_uuid')?.value } });
  }

  getConsigneeDetails() {
    this.router.navigate(['/contacts'], { queryParams: { contact_uuid: this.consignee_info.get('contact_uuid')?.value } });
  }

  promptEmail(contactType: string) {
    prompt('Email to ' + contactType + ' confirmation to:')
  }

  printPdf() {
    window.open('https://ams.ulaap.com/pages/work_orders/carrier_confirmation.php?uuid=' + this.general_info.get('lading_uuid')?.value, '_blank');
  }

  getCarrierList(): Observable<string[]> {
    return this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=carrier_contact_list').pipe(
      map(response => {
        if (response) {
          this.carrierFullList = response;
          return response.map(item => item.label);
        } else {
          return [];
        }
      })
    );
  }

  getShipperList(): Observable<string[]> {
    return this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=shipper_contact_list').pipe(
      map(response => {
        if (response) {
          this.shipperFullList = response;
          return response.map(item => item.label);
        } else {
          return [];
        }
      })
    );
  }

  getConsigneeList(): Observable<string[]> {
    return this.http.get<any[]>('/api/work_orders/contact_autofill.php?type=consignee_contact_list').pipe(
      map(response => {
        if (response) {
          this.consigneeFullList = response;
          return response.map(item => item.label);
        } else {
          return [];
        }
      })
    );
  }

  submitNewCarrierInfo() {
    const formData = this.new_carrier_info.value;

    this.http.post<any>(`/api/work_orders/set_carrier.php?lading_uuid=${this.general_info.get('lading_uuid')?.value}`, formData).subscribe(
      (response) => {
        // Handle the response from the server
        console.log('Form submitted successfully', response);
      },
      (error) => {
        // Handle errors
        console.error('Error submitting the form', error);
      }
    );
  }

  submitNewShipperInfo() {
    const formData = this.new_shipper_info.value;
    console.log(formData)

    this.http.post<any>(`/api/work_orders/set_shipper.php?lading_uuid=${this.general_info.get('lading_uuid')?.value}`, formData).subscribe(
      (response) => {
        // Handle the response from the server
        console.log('Form submitted successfully', response);
      },
      (error) => {
        // Handle errors
        console.error('Error submitting the form', error);
      }
    );
  }

  submitNewConsigneeInfo() {
    const formData = this.new_consignee_info.value;

    this.http.post<any>(`/api/work_orders/set_consignee.php?lading_uuid=${this.general_info.get('lading_uuid')?.value}`, formData).subscribe(
      (response) => {
        // Handle the response from the server
        console.log('Form submitted successfully', response);
      },
      (error) => {
        // Handle errors
        console.error('Error submitting the form', error);
      }
    );
  }

  submitOperationInfo() {
    const formData = this.operation_info.value;

    this.http.post<any>(`/api/work_orders/lading_operations.php`, formData).subscribe(
      (response) => {
        // Handle the response from the server
        console.log('Operation Form submitted successfully', response);
      },
      (error) => {
        // Handle errors
        console.error('Error submitting the Operation form', error);
      }
    );
  }

  submitCustomerCareInfo() {
    const formData = this.customer_care_info.value;

    this.http.post<any>(`/api/work_orders/lading_care.php`, formData).subscribe(
      (response) => {
        // Handle the response from the server
        console.log('customer care Form submitted successfully', response);
      },
      (error) => {
        // Handle errors
        console.error('Error submitting the customer care form', error);
      }
    );
  }

  submitSalesInfo() {
    const formData = this.sales_info.value;

    this.http.post<any>(`/api/work_orders/lading_sales.php`, formData).subscribe(
      (response) => {
        // Handle the response from the server
        console.log('Sales Form submitted successfully', response);
      },
      (error) => {
        // Handle errors
        console.error('Error submitting the sales form', error);
      }
    );
  }

  submitAdministrationInfo() {
    const formData = this.administration_info.value;

    console.log(formData);

    this.http.post<any>(`/api/work_orders/lading_administrations.php`, formData).subscribe(
      (response) => {
        // Handle the response from the server
        console.log('Sales Form submitted successfully', response);
      },
      (error) => {
        // Handle errors
        console.error('Error submitting the sales form', error);
      }
    );
  }

  onChangeCheckBox(event: any, controlName: string) {
    if (event.checked) {
      this.operation_info.get(controlName)?.setValue(true);
    }
    else {
      this.operation_info.get(controlName)?.setValue(null);
    }
  }

  onChangeCareCheckBox(event: any, controlName: string) {
    if (event.checked) {
      this.customer_care_info.get(controlName)?.setValue(true);
    }
    else {
      this.customer_care_info.get(controlName)?.setValue(null);
    }
  }

  onChangeSalesCheckBox(event: any, controlName: string) {
    if (event.checked) {
      this.sales_info.get(controlName)?.setValue(true);
    }
    else {
      this.sales_info.get(controlName)?.setValue(null);
    }
  }

  onChangeAdministrationCheckBox(event: any, controlName: string) {
    if (event.checked) {
      this.administration_info.get(controlName)?.setValue(true);
    }
    else {
      this.administration_info.get(controlName)?.setValue(null);
    }
  }

  /* -----------------------------------------------------------------------------------------


  FINANCIALS SECTION

  
  ----------------------------------------------------------------------------------------- */

  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    editable: (params: any) => this.isEditable(params),
    cellClass: 'cell-wrap-text',
    enableCellChangeFlash: true,
  }

  financialRowData: any[] = [];

  enableFinancialEditing() {
    this.isFinancialGridEditToggled = true;
  }

  disableFinancialEditing() {
    this.isFinancialGridEditToggled = false;
  }

  // Function to determine if a cell is editable based on category name for financials
  isEditable(params: any) {
    if (!this.isFinancialGridEditToggled) { // if not toggled on, return false so grid is not editable
      return false;
    } else {
      // Check the category name
      var categoryName = params.data.category;

      // Check column name (for discount rate specifically)
      var columnName = params.colDef.field;

      // List of category names where cells are uneditable
      var uneditableCategories = [
        'Fuel Surcharge',
        'Fuel Surcharge Plus',
        'Tax',
        'Gross',
        'Total'
      ];

      // "Discount Rate" category is only editable under the "Billable" column
      if (categoryName === 'Discount Rate' && columnName !== 'billable') {
        return false;
      }

      // Return true if the category is in the editable list, false otherwise
      return !uneditableCategories.includes(categoryName);
    }
  }

  onToggleChange() {

  }

  financialColumnDefs = [
    { field: 'lading_service_rate_uuid', headerName: 'Lading Service Rate UUID', editable: false, hide: true },
    { field: 'category', headerName: 'Category', editable: false, flex: 7 },
    {
      field: 'rated_cost',
      headerName: 'Rated Cost',
      flex: 1,
      cellEditorSelector: (params: any) => {
        if (params.data.category === 'Currency') {
          return {
            component: FinancialCurrencyEditorComponent,
            params: { value: params.value },
          };
        } else {
          return { component: 'agTextCellEditor' }; // Use default text cell editor
        }
      }
    },
    {
      field: 'actual_cost', headerName: 'Actual Cost', flex: 1,
      cellEditorSelector: (params: any) => {
        if (params.data.category === 'Currency') {
          return {
            component: FinancialCurrencyEditorComponent,
            params: { value: params.value },
          };
        } else {
          return { component: 'agTextCellEditor' }; // Use default text cell editor
        }
      }
    },
    {
      field: 'billable', headerName: 'Billable', flex: 1,
      cellEditorSelector: (params: any) => {
        if (params.data.category === 'Currency') {
          return {
            component: FinancialCurrencyEditorComponent,
            params: { value: params.value },
          };
        } else {
          return { component: 'agTextCellEditor' }; // Use default text cell editor
        }
      }
    }
  ]

  // open modal to add service charge to financial info
  openFinancialModal() {
    const modalRef = this.dialog.open(FinancialModalComponent, {
      data: {
        modalTitle: 'Add New Service Charge',
      },
    });

    // Subscribe to the form submission in the modal
    modalRef.afterClosed().subscribe((formData) => {
      console.log(formData)
      if (formData) {
        console.log('formData:', formData)
        // Add the new row to the financialRowData array
        this.addRowToFinancialData(formData.value);
      }
    });
  }

  openRemoveServiceModal() {
    const modalRef = this.dialog.open(RemoveServiceModalComponent, {

      data: {
        modalTitle: 'Remove Service Charge',
        serviceCategories: this.serviceCategories
      },

    });

    // Subscribe to the form submission in the modal
    modalRef.afterClosed().subscribe((formData) => {
      // URL to retrieve updated lading service rates
      const lading_services_url = `/api/work_orders/lading_service_rates.php?uuid=${this.uuid}`;

      if (formData) {
        const lading_service_rate_uuid = formData.value.selectedService
        const services_url = `/api/work_orders/lading_service_rates.php?lading_service_rate_uuid=${lading_service_rate_uuid}`
        console.log('formData:', formData)
        console.log(formData.value.selectedService)

        return this.http.delete<any>(services_url)
          .subscribe(response => {

            console.log('Delete Response', response)

            this.http.get<any>(lading_services_url).subscribe(response => {
              // update lading services array with service charge removed
              this.ladingServices = response;

              this.calculateRatedFinancials();
              this.calculateBillableFinancials();
              this.calculateActualFinancials();
            })

          })
      }

      return null;
    });
  }

  private addRowToFinancialData(formData: any) {
    // URL to post new service charge
    const services_url = '/api/work_orders/lading_service_rates.php'

    // URL to retrieve updated lading service rates
    const lading_services_url = `/api/work_orders/lading_service_rates.php?uuid=${this.uuid}`;

    // Create a new row object based on the form data
    // const newRow = {
    //   lading_service_rate_uuid: formData.lading_service_rate_uuid,
    //   category: formData.selectedService + ' | ' + formData.selectedServiceType,
    //   rated_cost: formData.rated_cost,
    //   actual_cost: formData.actual_cost,
    //   billable: formData.billable,
    // };

    var postData = {
      lading_uuid: this.uuid,
      lading_service_uuid: this.financialInfo.lading_service_uuid,
      lading_service_rate: formData.selectedService === '' ? null : formData.selectedService,
      lading_service_rate_type: formData.selectedServiceType === '' ? null : formData.selectedServiceType,
      service_cost: formData.rated_cost === '' ? null : formData.rated_cost,
      service_cost_actual: formData.actual_cost === '' ? null : formData.actual_cost,
      service_billed: formData.billable === '' ? null : formData.billable
    }

    return this.http.post<any>(services_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
        // update the lading services array with the newly added service charge
        this.http.get<any>(lading_services_url).subscribe(response => {
          this.ladingServices = response;

          // recalculate total rated costs if added service charge contains a rated cost
          if (postData.service_cost !== '') {
            this.calculateRatedFinancials()
          }

          // recalculate total actual costs if added service charge contains an actual cost
          if (postData.service_cost_actual !== '') {
            this.calculateActualFinancials()
          }

          // recalculate total billable costs if added service charge contains a billable cost
          if (postData.service_billed !== '') {
            this.calculateBillableFinancials()
          }
        })
      })
  }

  // allows editing of columns of Financials Grid, updates cells upon exiting out of the cell
  onCellEditingStopped(event: CellEditingStoppedEvent) {

    // grab value being edited, column, and row of node
    var editedValue = event.value;

    if (!isNaN(parseFloat(editedValue)) && isFinite(editedValue) || editedValue == '' || editedValue == 'USD' || editedValue == 'CAD') {
      const rowNode = event.node;
      const column = event.column;

      // grab category and column name of node
      const columnName = column.getColId();
      const categoryName = rowNode.data.category

      // const themeElement = document.querySelector('--ag-value-change-value-highlight-background-color');

      this.gridApi.flashCells({
        rowNodes: [rowNode],
        columns: [columnName],
        flashDuration: 3000,
        fadeDuration: 2000
      })

      // grab UUIDs to send to API call
      const lading_service_uuid = this.financialInfo.lading_service_uuid;
      const service_rate_uuid = rowNode.data.lading_service_rate_uuid;

      // create URLs to send POST data to
      const financial_url = '/api/work_orders/work_order_details_financial.php'
      const services_url = '/api/work_orders/lading_service_rates.php'

      // if empty cell, set value to null
      if (editedValue == "") {
        editedValue = null;
      }

      var postData = {}

      // if an edit is made on the financials info which is NOT an added service charge
      if (service_rate_uuid == null) {
        switch (columnName) {
          case 'rated_cost':
            switch (categoryName) {
              case 'Currency':
                this.financialInfo.cost_currency_type = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "cost_currency_type": editedValue,
                }
                break;
              case 'Freight Net Cost':
                this.financialInfo.freight_net_cost = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "freight_net_cost": editedValue,
                }
                break;
              case 'Fuel Surcharge Rate':
                this.financialInfo.fuel_surcharge_rate_cost = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_rate_cost": editedValue,
                }
                console.log(postData)
                break;
              case 'Fuel Surcharge Plus Rate':
                this.financialInfo.fuel_surcharge_plus_rate_cost = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_plus_rate_cost": editedValue,
                }
                break;
              case 'Beyond':
                this.financialInfo.beyond_cost = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "beyond_cost": editedValue,
                }
                break;
              case 'Tax Rate':
                this.financialInfo.tax_rate_multiplier = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "tax_rate_multiplier": editedValue,
                }
                break;
            }
            break;
          case 'actual_cost':
            console.log('this is actual cost');
            switch (categoryName) {
              case 'Currency':
                this.financialInfo.actual_currency_type = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "actual_currency_type": editedValue,
                }
                break;
              case 'Freight Net Cost':
                this.financialInfo.freight_net_cost_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "freight_net_cost_actual": editedValue,
                }
                break;
              case 'Fuel Surcharge Rate':
                this.financialInfo.fuel_surcharge_rate_cost_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_rate_cost_actual": editedValue,
                }
                break;
              case 'Fuel Surcharge Plus Rate':
                this.financialInfo.fuel_surcharge_plus_rate_cost_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_plus_rate_cost_actual": editedValue,
                }
                break;
              case 'Beyond':
                this.financialInfo.beyond_cost_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "beyond_cost_actual": editedValue,
                }
                break;
              case 'Tax Rate':
                this.financialInfo.tax_rate_multiplier_actual = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "tax_rate_multiplier_actual": editedValue,
                }
                break;
            }
            break;
          case 'billable':
            console.log('this is billable')
            switch (categoryName) {
              case 'Currency':
                this.financialInfo.chargeable_currency_type = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "chargeable_currency_type": editedValue,
                }
                break;
              case 'Freight Net Cost':
                this.financialInfo.freight_net_billable = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "freight_net_billable": editedValue,
                }
                break;
              case 'Fuel Surcharge Rate':
                this.financialInfo.fuel_surcharge_rate_billed = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_rate_billed": editedValue,
                }
                break;
              case 'Fuel Surcharge Plus Rate':
                this.financialInfo.fuel_surcharge_plus_rate_billed = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "fuel_surcharge_plus_rate_billed": editedValue,
                }
                break;
              case 'Beyond':
                this.financialInfo.beyond_billed = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "beyond_billed": editedValue,
                }
                break;
              case 'Discount Rate':
                this.financialInfo.discount_rate = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "discount_rate": editedValue,
                }
                break;
              case 'Tax Rate':
                this.financialInfo.tax_rate_billed_multiplier = editedValue
                postData = {
                  lading_service_uuid: lading_service_uuid,
                  "tax_rate_billed_multiplier": editedValue,
                }
                break;
            }
            break;
          default:
            console.log('Unnamed Column');
        }

        return this.http.post<any>(financial_url, postData)
          .subscribe(response => {
            console.log('Post Response: ', response)
            if (columnName == 'rated_cost') {
              this.calculateRatedFinancials()
            } else if (columnName == 'billable') {
              this.calculateBillableFinancials()
            } else if (columnName == 'actual_cost') {
              this.calculateActualFinancials()
            }
          })

        // if an edit is made on an added service charge
      } else {

        // Find the corresponding service in ladingServices array
        const editedServiceIndex = this.ladingServices.findIndex(service => service['lading_service_rate_uuid'] === service_rate_uuid);

        // ensure service exists before making changes
        if (editedServiceIndex !== -1) {
          switch (columnName) {
            case 'rated_cost':
              this.ladingServices[editedServiceIndex]['service_cost'] = editedValue
              postData = {
                lading_service_rate_uuid: service_rate_uuid,
                "service_cost": editedValue,
              }
              break;
            case 'actual_cost':
              this.ladingServices[editedServiceIndex]['service_cost_actual'] = editedValue
              postData = {
                lading_service_rate_uuid: service_rate_uuid,
                "service_cost_actual": editedValue,
              }
              break;
            case 'billable':
              this.ladingServices[editedServiceIndex]['service_billed'] = editedValue
              postData = {
                lading_service_rate_uuid: service_rate_uuid,
                "service_billed": editedValue,
              }
              break;
          }
        }

        return this.http.post<any>(services_url, postData)
          .subscribe(response => {
            console.log('Post Response: ', response)
            if (columnName == 'rated_cost') {
              this.calculateRatedFinancials()
            } else if (columnName == 'billable') {
              this.calculateBillableFinancials()
            } else if (columnName == 'actual_cost') {
              this.calculateActualFinancials()
            }
          })
      }

    } else {
      this.updateFinancialRows();
      return null;
    }

  }

  // Calculations for the Rated Cost column in Financials Grid
  calculateRatedFinancials() {
    var subtotal = 0;
    var total = 0;
    const freight_cost = parseFloat(this.financialInfo.freight_net_cost)
    const beyond_cost = parseFloat(this.financialInfo.beyond_cost)
    var fuel_surcharge = parseFloat(this.financialInfo.fuel_surcharge_rate_cost)
    var fuel_surcharge_plus = parseFloat(this.financialInfo.fuel_surcharge_plus_rate_cost)
    var tax = parseFloat(this.financialInfo.tax_rate_multiplier)

    // Add freight_cost to subtotal if it's not null
    if (!isNaN(freight_cost) && freight_cost !== null) {
      subtotal += freight_cost;
    }

    // Add beyond_cost to subtotal if it's not null
    if (!isNaN(beyond_cost) && beyond_cost !== null) {
      subtotal += beyond_cost;
    }

    // loop through each lading service (if any)
    this.ladingServices.forEach(service => {
      if (service['service_cost'] !== null) {
        const cost = service['service_cost']
        const costValue = parseFloat(cost.toString());

        if (!isNaN(costValue)) {
          subtotal += costValue;
        }

      }
    })

    // update gross cost
    this.financialInfo.gross_costs = subtotal.toFixed(2)

    // if fuel_surcharge rate is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge) && fuel_surcharge > 0) {
      var fuel_surcharge_cost = freight_cost * fuel_surcharge
      this.financialInfo.fuel_surcharge_cost = fuel_surcharge_cost.toFixed(2)
      subtotal = subtotal + fuel_surcharge_cost
      this.financialInfo.gross_costs = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_cost = ''
    }

    // if fuel_surcharge rate plus is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge_plus) && fuel_surcharge_plus > 0) {
      var fuel_surcharge_plus_cost = freight_cost * fuel_surcharge_plus
      this.financialInfo.fuel_surcharge_plus_cost = fuel_surcharge_plus_cost.toFixed(2)
      subtotal = subtotal + fuel_surcharge_plus_cost
      this.financialInfo.gross_costs = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_plus_cost = ''
    }

    // apply taxes if applicable
    if (!isNaN(tax) && tax > 0) {
      var tax_cost = subtotal * tax;
      total = subtotal + tax_cost
      this.financialInfo.costs_taxes = tax_cost.toFixed(2)
      this.financialInfo.total_costs = total.toFixed(2)
    } else {
      // if tax rate is deleted, remove tax cost
      this.financialInfo.costs_taxes = ''
      total = subtotal
      this.financialInfo.total_costs = total.toFixed(2)
    }

    // update the financial row data with the updated calculations
    this.updateFinancialRows()

    // after updating, update database with final calculations
    const financial_url = '/api/work_orders/work_order_details_financial.php'
    const lading_service_uuid = this.financialInfo.lading_service_uuid;

    // Function to replace empty strings with null
    function replaceEmptyWithNull(value: string) {
      return value === '' ? null : value;
    }

    var postData = {
      lading_service_uuid: lading_service_uuid,
      // there is no field within the lading services table for fuel_surcharge_costs:
      // "fuel_surcharge_cost": this.financialInfo.fuel_surcharge_cost,
      // "fuel_surcharge_plus_cost": this.financialInfo.fuel_surcharge_plus_cost,
      "costs_taxes": replaceEmptyWithNull(this.financialInfo.costs_taxes),
      "gross_costs": replaceEmptyWithNull(this.financialInfo.gross_costs),
      "total_costs": replaceEmptyWithNull(this.financialInfo.total_costs)
    }

    return this.http.post<any>(financial_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
  }

  // Calculations for the Actual Cost column in Financials Grid
  calculateActualFinancials() {
    var subtotal = 0;
    var total = 0;
    const freight_cost = parseFloat(this.financialInfo.freight_net_cost_actual)
    const beyond_cost = parseFloat(this.financialInfo.beyond_cost_actual)
    var fuel_surcharge = parseFloat(this.financialInfo.fuel_surcharge_rate_cost_actual)
    var fuel_surcharge_plus = parseFloat(this.financialInfo.fuel_surcharge_plus_rate_cost_actual)
    var tax = parseFloat(this.financialInfo.tax_rate_multiplier_actual)

    // Add freight_cost to subtotal if it's not null
    if (!isNaN(freight_cost) && freight_cost !== null) {
      subtotal += freight_cost;
    }

    // Add beyond_cost to subtotal if it's not null
    if (!isNaN(beyond_cost) && beyond_cost !== null) {
      subtotal += beyond_cost;
    }

    // loop through each lading service (if any)
    this.ladingServices.forEach(service => {
      if (service['service_cost_actual'] !== null) {
        const cost = service['service_cost_actual']
        const costValue = parseFloat(cost.toString());

        if (!isNaN(costValue)) {
          subtotal += costValue;
        }

      }
    })

    // update gross cost
    this.financialInfo.gross_costs_actual = subtotal.toFixed(2)

    // if fuel_surcharge rate is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge) && fuel_surcharge > 0) {
      var fuel_surcharge_cost_actual = freight_cost * fuel_surcharge
      this.financialInfo.fuel_surcharge_cost_actual = fuel_surcharge_cost_actual.toFixed(2)
      subtotal = subtotal + fuel_surcharge_cost_actual
      this.financialInfo.gross_costs_actual = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_cost_actual = ''
    }

    // if fuel_surcharge rate plus is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge_plus) && fuel_surcharge_plus > 0) {
      var fuel_surcharge_plus_cost_actual = freight_cost * fuel_surcharge_plus
      this.financialInfo.fuel_surcharge_plus_cost_actual = fuel_surcharge_plus_cost_actual.toFixed(2)
      subtotal = subtotal + fuel_surcharge_plus_cost_actual
      this.financialInfo.gross_costs_actual = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_plus_cost_actual = ''
    }

    // apply taxes if applicable
    if (!isNaN(tax) && tax > 0) {
      var tax_cost = subtotal * tax;
      total = subtotal + tax_cost
      this.financialInfo.costs_taxes_actual = tax_cost.toFixed(2)
      this.financialInfo.total_costs_actual = total.toFixed(2)
    } else {
      // if tax rate is deleted, remove tax cost
      this.financialInfo.costs_taxes_actual = ''
      total = subtotal
      this.financialInfo.total_costs_actual = total.toFixed(2)
    }

    // update the financial row data with the updated calculations
    this.updateFinancialRows()

    // after updating, update database with final calculations
    const financial_url = '/api/work_orders/work_order_details_financial.php'
    const lading_service_uuid = this.financialInfo.lading_service_uuid;

    // Function to replace empty strings with null
    function replaceEmptyWithNull(value: string) {
      return value === '' ? null : value;
    }

    var postData = {
      lading_service_uuid: lading_service_uuid,
      // there is no field within the lading services table for fuel_surcharge_costs:
      // "fuel_surcharge_cost": this.financialInfo.fuel_surcharge_cost,
      // "fuel_surcharge_plus_cost": this.financialInfo.fuel_surcharge_plus_cost,
      "costs_taxes_actual": replaceEmptyWithNull(this.financialInfo.costs_taxes_actual),
      "gross_costs_actual": replaceEmptyWithNull(this.financialInfo.gross_costs_actual),
      "total_costs_actual": replaceEmptyWithNull(this.financialInfo.total_costs_actual)
    }

    return this.http.post<any>(financial_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
  }

  // Calculations for the Billable column in Financials Grid
  calculateBillableFinancials() {
    var subtotal = 0;
    var total = 0;
    const freight_cost = parseFloat(this.financialInfo.freight_net_billable)
    const beyond_cost = parseFloat(this.financialInfo.beyond_billed)
    const discount = parseFloat(this.financialInfo.discount_rate)
    var fuel_surcharge = parseFloat(this.financialInfo.fuel_surcharge_rate_billed)
    var fuel_surcharge_plus = parseFloat(this.financialInfo.fuel_surcharge_plus_rate_billed)
    var tax = parseFloat(this.financialInfo.tax_rate_billed_multiplier)

    // Add freight_cost to subtotal if it's not null
    if (!isNaN(freight_cost) && freight_cost !== null) {
      subtotal += freight_cost;
    }

    // Add beyond_cost to subtotal if it's not null
    if (!isNaN(beyond_cost) && beyond_cost !== null) {
      subtotal += beyond_cost;
    }

    // loop through each lading service (if any)
    this.ladingServices.forEach(service => {
      if (service['service_billed'] !== null) {
        const cost = service['service_billed']
        const costValue = parseFloat(cost.toString());

        if (!isNaN(costValue)) {
          subtotal += costValue;
        }

      }
    })

    // update gross cost
    this.financialInfo.gross_billed = subtotal.toFixed(2)

    // if fuel_surcharge rate is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge) && fuel_surcharge > 0) {
      var fuel_surcharge_billed = freight_cost * fuel_surcharge
      this.financialInfo.fuel_surcharge_billed = fuel_surcharge_billed.toFixed(2)
      subtotal = subtotal + fuel_surcharge_billed
      this.financialInfo.gross_billed = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_billed = ''
    }

    // if fuel_surcharge rate plus is assigned, apply to subtotal
    if (!isNaN(fuel_surcharge_plus) && fuel_surcharge_plus > 0) {
      var fuel_surcharge_plus_billed = freight_cost * fuel_surcharge_plus
      this.financialInfo.fuel_surcharge_plus_billed = fuel_surcharge_plus_billed.toFixed(2)
      subtotal = subtotal + fuel_surcharge_plus_billed
      this.financialInfo.gross_billed = subtotal.toFixed(2)
    } else {
      // if rate is deleted, remove the surcharge cost
      this.financialInfo.fuel_surcharge_plus_billed = ''
    }

    // if discount is applicable
    if (!isNaN(discount) && discount > 0) {
      subtotal = subtotal - (subtotal * discount)
    }

    // apply taxes if applicable
    if (!isNaN(tax) && tax > 0) {
      var tax_cost = subtotal * tax;
      total = subtotal + tax_cost
      this.financialInfo.billable_taxes = tax_cost.toFixed(2)
      this.financialInfo.total_charged = total.toFixed(2)
    } else {
      // if tax rate is deleted, remove tax cost
      this.financialInfo.billable_taxes = ''
      total = subtotal
      this.financialInfo.total_charged = total.toFixed(2)
    }

    // update the financial row data with the updated calculations
    this.updateFinancialRows()

    // after updating, update database with final calculations
    const financial_url = '/api/work_orders/work_order_details_financial.php'
    const lading_service_uuid = this.financialInfo.lading_service_uuid;

    // Function to replace empty strings with null
    function replaceEmptyWithNull(value: string) {
      return value === '' ? null : value;
    }

    var postData = {
      lading_service_uuid: lading_service_uuid,
      // there is no field within the lading services table for fuel_surcharge_costs:
      // "fuel_surcharge_cost": this.financialInfo.fuel_surcharge_cost,
      // "fuel_surcharge_plus_cost": this.financialInfo.fuel_surcharge_plus_cost,
      "billable_taxes": replaceEmptyWithNull(this.financialInfo.billable_taxes),
      "gross_billed": replaceEmptyWithNull(this.financialInfo.gross_billed),
      "total_charged": replaceEmptyWithNull(this.financialInfo.total_charged)
    }

    return this.http.post<any>(financial_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
  }

  updateFinancialRows() {

    this.financialRowData = [
      { lading_service_rate_uuid: null, category: 'Currency', rated_cost: this.financialInfo.cost_currency_type, actual_cost: this.financialInfo.actual_currency_type, billable: this.financialInfo.chargeable_currency_type },
      { lading_service_rate_uuid: null, category: 'Freight Net Cost', rated_cost: this.financialInfo.freight_net_cost, actual_cost: this.financialInfo.freight_net_cost_actual, billable: this.financialInfo.freight_net_billable },
      { lading_service_rate_uuid: null, category: 'Fuel Surcharge Rate', rated_cost: this.financialInfo.fuel_surcharge_rate_cost, actual_cost: this.financialInfo.fuel_surcharge_rate_cost_actual, billable: this.financialInfo.fuel_surcharge_rate_billed },
      { lading_service_rate_uuid: null, category: 'Fuel Surcharge Plus Rate', rated_cost: this.financialInfo.fuel_surcharge_plus_rate_cost, actual_cost: this.financialInfo.fuel_surcharge_plus_rate_cost_actual, billable: this.financialInfo.fuel_surcharge_plus_rate_billed },
      { lading_service_rate_uuid: null, category: 'Fuel Surcharge', rated_cost: this.financialInfo.fuel_surcharge_cost, actual_cost: this.financialInfo.fuel_surcharge_cost_actual, billable: this.financialInfo.fuel_surcharge_billed },
      { lading_service_rate_uuid: null, category: 'Fuel Surcharge Plus', rated_cost: this.financialInfo.fuel_surcharge_plus_cost, actual_cost: this.financialInfo.fuel_surcharge_plus_cost_actual, billable: this.financialInfo.fuel_surcharge_plus_billed },
      { lading_service_rate_uuid: null, category: 'Beyond', rated_cost: this.financialInfo.beyond_cost, actual_cost: this.financialInfo.beyond_cost_actual, billable: this.financialInfo.beyond_billed },
      { lading_service_rate_uuid: null, category: 'Discount Rate', rated_cost: '', actual_cost: '', billable: this.financialInfo.discount_rate },
      { lading_service_rate_uuid: null, category: 'Tax Rate', rated_cost: this.financialInfo.tax_rate_multiplier, actual_cost: this.financialInfo.tax_rate_multiplier_actual, billable: this.financialInfo.tax_rate_billed_multiplier },
      { lading_service_rate_uuid: null, category: 'Tax', rated_cost: this.financialInfo.costs_taxes, actual_cost: this.financialInfo.costs_taxes_actual, billable: this.financialInfo.billable_taxes },
      { lading_service_rate_uuid: null, category: 'Gross', rated_cost: this.financialInfo.gross_costs, actual_cost: this.financialInfo.gross_costs_actual, billable: this.financialInfo.gross_billed },
      { lading_service_rate_uuid: null, category: 'Total', rated_cost: this.financialInfo.total_costs, actual_cost: this.financialInfo.total_costs_actual, billable: this.financialInfo.total_charged },
    ]

    // index to insert any lading services to the financial info
    let rowIndex = 7;

    // if lading services exist, add to the financial info data
    this.ladingServices.forEach((rowDataObject) => {
      // Create a new row based on the service
      const newRow = {
        lading_service_rate_uuid: rowDataObject['lading_service_rate_uuid'],
        category: rowDataObject['lading_service_rate'] + " | " + rowDataObject['lading_service_rate_type'],
        rated_cost: rowDataObject['service_cost'],
        actual_cost: rowDataObject['service_cost_actual'],
        billable: rowDataObject['service_billed'],
      };

      // Insert the new service at the 6th index
      this.financialRowData.splice(rowIndex, 0, newRow);
      rowIndex++;
    });

    // Populate service categories array for remove-service-modal
    this.serviceCategories = this.ladingServices.map(service => ({
      category: `${service['lading_service_rate']} | ${service['lading_service_rate_type']}`,
      uuid: service['lading_service_rate_uuid']
    }));

  }


  /* -----------------------------------------------------------------------------------------


  PRODUCTS SECTION

  
  ----------------------------------------------------------------------------------------- */

  productsList: any[] = []

  productsColumnDefs = [
    {
      field: 'delivered',
      headerName: 'Delivered',
      valueFormatter: function (params: ValueFormatterParams) {
        return params.value === "false" || params.value === null ? '❌' : '✅';
      }
    },
    { field: 'delivered_time', headerName: 'Delivered Time' },
    { field: 'description', headerName: 'Description' },
    { field: 'barcode', headerName: 'Barcode' },
    { field: 'product_model_number', headerName: 'Product Model Number' },
    { field: 'product_serial_number', headerName: 'Product Serial Number' }
  ]

  productsDefaultColDefs = {
    sortable: true,
    filter: true,
    resizable: true,
    editable: false,
    cellClass: 'cell-wrap-text',
  }

  exportCsv() {
    this.gridApi!.exportDataAsCsv();
  }



//Document upload
 // Handle when files are dragged over the dropzone
 handleDocumentDragOver(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDraggingOverDocument = true;
}

// Handle when files leave the dropzone
handleDocumentDragLeave(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDraggingOverDocument = false;
}

// Handle the file drop event and prompt for document type selection before uploading
handleDocumentDrop(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDraggingOverDocument = false;

  if (event.dataTransfer?.files.length) {
    const files = event.dataTransfer.files;
    const formData = new FormData();

    // Append the dropped files to FormData
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i], files[i].name);
    }

    // Append the lading_uuid to FormData, provide a fallback if it's null
    formData.append('lading_uuid', this.uuid || ''); // Fallback to an empty string if this.uuid is null
    //add the alt ref for the UFOs so we can get abducted
    formData.append('alternate_reference', this.general_info.get('alternate_reference')?.value || '');
    // Open the document type selection dialog BEFORE uploading
    this.openDocumentTypeDialog(formData);
  }
}

// Open the document type selection dialog
openDocumentTypeDialog(formData: FormData) {
  const dialogRef = this.dialog.open(DocumentTypeSelectionDialog, {
    width: '400px'
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      // Attach document type value and name to the form data
      formData.append('document_type', result.value.toString());  // Pass the value (e.g., '1')
      formData.append('file_description', result.name);  // Pass the document type name

      // Proceed with the upload
      this.uploadDocumentFiles(formData);
    } else {
      console.log('Document type selection was canceled.');
    }
  });
}

// Upload the file to the backend with the selected document type and lading_uuid
uploadDocumentFiles(formData: FormData) {
  const uploadUrl = 'api/documents/document_upload.php'; // Your actual PHP upload URL

  this.http.post(uploadUrl, formData).subscribe(
    (response: any) => {
      // Check if the upload was successful based on the response from the backend
      if (response.success) {
        // Handle successful upload
        console.log('Files uploaded successfully', response);
        
        this.showSuccessMessage('File uploaded successfully.');
        this.refreshDocumentList();
      } else {
        // Handle failure 
        console.error('Error uploading file:', response.message);
        // Show an error message
        this.showErrorMessage(`File upload failed: ${response.message}`);
      }
    },
    (error) => {
      // Handle HTTP errors 
      console.error('HTTP Error during file upload:', error);
      this.showErrorMessage('An error occurred while uploading the file. Please try again.');
    }
  );
}

// Fetch the updated document list from the backend
refreshDocumentList() {
  const documentsUrl = `/api/work_orders/order_documents.php?uuid=${this.uuid}`;
  
  this.http.get<any>(documentsUrl).subscribe(response => {
    if (response) {
      this.documentList = response;  // Update the document list on the page
      console.log('Document list updated', this.documentList);
    }
  });
}

// Helper methods for displaying toastr notifications
showSuccessMessage(message: string) {
  this.toastr.success(message, 'Success');
}

showErrorMessage(message: string) {
  this.toastr.error(message, 'Error');
}
}

@Component({
  selector: 'documents-modal',
  templateUrl: './documents-modal.html',
  standalone: true,
  imports: [
    MatDialogModule,
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ]
})
export class DocumentModalComponent {
  public fileURL: string = 'default';
  constructor(
    public dialogRef: MatDialogRef<DocumentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
